if (document.getElementsByClassName("pio-meta-json").length <= 0) {
    var pioShop = typeof Shopify !== "undefined" ? Shopify.shop : pioShopName;
    var pioShopDomain = document.domain;
    var pioBasePath = "https://" + pioShopDomain + "/a/pio/";
    var pioProductData = "";
    //var loadCss = pioBasePath + 'css/pio-style.css';
    var $pioobject = "";
    var pioLanguageSettings = "";
    var pioOptionSets = "";
    var cartObject = "";
    var pioJson = "";
    //var pioShopCurrency = Shopify.currency.active;
    var storeCurrency = "";
    var plan_id = 1;
    var planTierValue = 0;
    var isOldUserFlag = false;
  
    function pioRunWithJQuery(pioLoadMain) {  
        if (typeof jQuery == 'undefined') {
            var pioHead = document.getElementsByTagName('head')[0];
            var pioScript = document.createElement('script');
            // Use CDN fallback instead of local path
            pioScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js';
            // pioScript.src = pioBasePath + 'js/lib/jquery-3.4.1.min.js';
            pioScript.type = 'text/javascript';
            pioScript.onreadystatechange = pioLoadMain;
            pioScript.onload = pioLoadMain;
            pioScript.onerror = function() {
                // Fallback to another CDN if the first one fails
                var pioScriptFallback = document.createElement('script');
                pioScriptFallback.src = 'https://code.jquery.com/jquery-3.4.1.min.js';
                pioScriptFallback.type = 'text/javascript';
                pioScriptFallback.onload = pioLoadMain;
                pioHead.appendChild(pioScriptFallback);
            };
            // Fire the loading
            pioHead.appendChild(pioScript);
        } else {
            pioLoadMain();
        }  
    }
    pioRunWithJQuery(function pioLoadMain() {
    (function ($pioobject, window, document) {
      $pioobject.fn.pioLoad = function () {
        if (typeof jQuery == "undefined") {
          var pioHead = document.getElementsByTagName("head")[0];
          var pioScript = document.createElement("script");
          pioScript.src = pioBasePath + "js/lib/library.min.js";
          pioScript.type = "text/javascript";
          pioScript.onreadystatechange = pioHandler;
          pioScript.onload = this.pioHandler();
          // Fire the loading
          pioHead.appendChild(pioScript);
        } else {
          this.pioHandler();
        }
      };
      sortJSON = function (arr, key, way) {
        return arr.sort(function (a, b) {
          var x = a[key];
          var y = b[key];
          if (way === "asc") {
            return x < y ? -1 : x > y ? 1 : 0;
          }
          if (way === "desc") {
            return x > y ? -1 : x < y ? 1 : 0;
          }
        });
      };
      // Function to handle plan data and old user flag
      // Returns object with isOldUserFlag (boolean) and planTierValue (number)
      var handlePlansData = function(isOldUser, planTier) {
        var isOldUserFlag = false;
        var planTierValue = 0;

        if (isOldUser == 1 || isOldUser == true) {
          isOldUserFlag = true;
          if (planTier === "basic") {
            planTierValue = 1;
          } else if (planTier === "advance") {
            planTierValue = 2;
          } else if (planTier === "professional") {
            planTierValue = 3;
          }
          return {isOldUserFlag: isOldUserFlag, planTierValue: planTierValue};
        } else {
          isOldUserFlag = false;
          if (planTier === "free") {
            planTierValue = 1;
          } else if (planTier === "standard") {
            planTierValue = 2;
          } else if (planTier === "enterprise") {
            planTierValue = 3;
          }
          return {isOldUserFlag: isOldUserFlag, planTierValue: planTierValue};
        }
      };
      
      // Function to filter field data based on old user flag and plan tier
      // Returns filtered field object with only allowed properties
      var filterFieldData = function(field) {
        var filteredField = {};

        // New user (isOldUserFlag is false) - only allow keys by plan tier
        if (!isOldUserFlag) {
          var newUserTier1Keys = ['option_type', 'label', 'name', 'required', 'placeholder', 'html_class', 'height', 'allow_multiple', 'option_values'];
          var newUserTier2Keys = ['option_type', 'label', 'name', 'required', 'placeholder', 'html_class', 'height',
            'hidden_label', 'min_character', 'max_character', 'show_character_counter', 'default_value', 'selected_by_default',
            'addon_price', 'allow_multiple', 'allowed_extensions', 'option_values', 'content', 'color', 'heading_style', 'border_style', 'thickness', 'html_code'];
          var newUserTier3Keys = ['option_type', 'label', 'name', 'required', 'placeholder', 'html_class', 'height',
            'hidden_label', 'min_character', 'max_character', 'show_character_counter', 'default_value', 'selected_by_default',
            'allow_multiple', 'allowed_extensions', 'option_values', 'content', 'color', 'heading_style', 'border_style', 'thickness', 'html_code',
            'addon_price', 'help_text', 'help_text_position', 'allowed_value', 'text_transform', 'column_width', 'format', 'mode', 'date_format',
            'default_country', 'min_selection', 'max_selection', 'swatch_image_width', 'swatch_image_height', 'tooltip_style', 'swatch_style',
            'swatch_color_width', 'swatch_color_height', 'modal_title', 'modal_content'];

          var keysToUse = planTierValue === 1 ? newUserTier1Keys : (planTierValue === 2 ? newUserTier2Keys : newUserTier3Keys);
          for (var idx = 0; idx < keysToUse.length; idx++) {
            var k = keysToUse[idx];
            if (field.hasOwnProperty(k)) {
              filteredField[k] = field[k];
            }
          }
          // When isOldUserFlag is false and planTierValue is not 3, option_value price must not render
          if (planTierValue === 1 && filteredField.option_values && Array.isArray(filteredField.option_values)) {
            filteredField.option_values = filteredField.option_values.map(function(opt) {
              var o = {};
              if (opt.hasOwnProperty('label')) o.label = opt.label;
              if (opt.hasOwnProperty('image')) o.image = opt.image;
              if (opt.hasOwnProperty('color')) o.color = opt.color;
              o.price = "";
              return o;
            });
          }
          return filteredField;
        }

        // Old user (isOldUserFlag is true)
        // If old user flag is true and planTierValue is 2
        // Only allow: label, name, required, placeholder, html_class, allow_multiple
        if (planTierValue === 2) {
          var tier2AllowedKeys = ['label', 'name', 'required', 'placeholder', 'html_class', 'allow_multiple', 'option_type', 'option_values', 'allowed_extensions'];
          
          for (var i = 0; i < tier2AllowedKeys.length; i++) {
            var key = tier2AllowedKeys[i];
            if (field.hasOwnProperty(key)) {
              filteredField[key] = field[key];
            }
          }
          
          // Copy option_values without price when isOldUserFlag and planTierValue is not 3
          if (field.option_values && Array.isArray(field.option_values)) {
            filteredField.option_values = field.option_values.map(function(opt) {
              var filteredOpt = {};
              if (opt.hasOwnProperty('label')) filteredOpt.label = opt.label;
              filteredOpt.price = ""; // option_value price must not render for tier 2
              return filteredOpt;
            });
          }
        }
        // If old user flag is true and planTierValue is 1 (or not 2 and not 3)
        // Only allow: label, name, required, placeholder, html_class; option_value price must not render
        else if (planTierValue === 1) {
          var allowedKeys = ['label', 'name', 'required', 'placeholder', 'html_class', 'option_type', 'option_values', 'allowed_extensions'];
          
          for (var i = 0; i < allowedKeys.length; i++) {
            var key = allowedKeys[i];
            if (field.hasOwnProperty(key)) {
              filteredField[key] = field[key];
            }
          }
          
          if (field.option_values && Array.isArray(field.option_values)) {
            filteredField.option_values = field.option_values.map(function(opt) {
              var filteredOpt = {};
              if (opt.hasOwnProperty('label')) filteredOpt.label = opt.label;
              filteredOpt.price = ""; // option_value price must not render when isOldUserFlag and planTierValue is not 3
              return filteredOpt;
            });
          }
        } 
        // If old user flag is true and planTierValue IS 3
        // Allow: label, name, required, placeholder, html_class, price (addon_price)
        else if (planTierValue === 3) {
          var allowedKeysWithPrice = ['label', 'name', 'required', 'placeholder', 'html_class', 'allow_multiple', 'option_type', 'option_values', 'addon_price', 'allowed_extensions'];
          
          // Copy only allowed properties including price
          for (var j = 0; j < allowedKeysWithPrice.length; j++) {
            var keyWithPrice = allowedKeysWithPrice[j];
            if (field.hasOwnProperty(keyWithPrice)) {
              filteredField[keyWithPrice] = field[keyWithPrice];
            }
          }
          
          // Copy option_values if it exists (including price for tier 3)
          if (field.option_values && Array.isArray(field.option_values)) {
            filteredField.option_values = field.option_values;
          }
        }
        
        return filteredField;
      };
      pioLoadfields = function (optionset) {
        var optionsetOptions = sortJSON(optionset.options, "sort_number", "asc");
        var pioFieldHtml = "";
        $pioobject.each(optionsetOptions, function (key, field) {
          // Check if old user flag is true, then only allow specific option types (1, 4, 7, 8, 10, 13, 15)
          if (isOldUserFlag === true) {
            var allowedOptionTypes = [1, 4, 7, 8, 10, 13, 15];
            if (allowedOptionTypes.indexOf(field.option_type) === -1) {
              return; // Skip rendering this field
            }
          }

          // When isOldUserFlag is false and planTierValue is 1, only allow option types (1, 4, 6, 10, 11, 13, 15, 18)
          if (isOldUserFlag === false && planTierValue === 1) {
            var tier1AllowedOptionTypes = [1, 4, 6, 10, 11, 13, 15, 18];
            if (tier1AllowedOptionTypes.indexOf(field.option_type) === -1) {
              return; // Skip rendering this field
            }
          }

          // When isOldUserFlag is false and planTierValue is 2, only allow option types (1, 4, 6, 10, 11, 13, 15, 18, 2, 5, 7, 8, 16, 17, 19, 20)
          if (isOldUserFlag === false && planTierValue === 2) {
            var tier2AllowedOptionTypes = [1, 4, 6, 10, 11, 13, 15, 18, 2, 5, 7, 8, 16, 17, 19, 20];
            if (tier2AllowedOptionTypes.indexOf(field.option_type) === -1) {
              return; // Skip rendering this field
            }
          }
          
          // Filter field data based on old user flag and plan tier
          var filteredField = filterFieldData(field);
          filteredField.option_set_id = field.option_set_id != null ? field.option_set_id : (optionset.id != null ? optionset.id : optionset.option_set_id);
          filteredField.option_id = field.option_id != null ? field.option_id : field.id;
          console.log('filteredField', filteredField)

          // Check validation
          switch (filteredField.option_type) {
            case 1:
              pioFieldHtml += loadTextBox(key, filteredField);
              break;
            case 2:
              pioFieldHtml += loadEmail(key, filteredField);
              break;
            case 3:
              pioFieldHtml += loadColorPicker(key, filteredField);
              break;
            case 4:
              pioFieldHtml += loadTextArea(key, filteredField);
              break;
            case 5:
              pioFieldHtml += loadSwitch(key, filteredField);
              break;
            case 6:
              pioFieldHtml += loadNumber(key, filteredField);
              break;
            case 7:
              pioFieldHtml += loadDatepicker(key, filteredField);
              break;
            case 8:
              pioFieldHtml += loadImageUpload(key, filteredField);
              break;
            case 9:
              pioFieldHtml += loadPhone(key, filteredField);
              break;
            case 10:
              pioFieldHtml += loadSelectBox(key, filteredField);
              break;
            case 11:
              pioFieldHtml += loadButton(key, filteredField);
              break;
            case 12:
              pioFieldHtml += loadImageSwatch(key, filteredField);
              break;
            case 13:
              pioFieldHtml += loadCheckBox(key, filteredField);
              break;
            case 14:
              pioFieldHtml += loadColorSwatch(key, filteredField);
              break;
            case 15:
              pioFieldHtml += loadRadio(key, filteredField);
              break;
            case 16:
              pioFieldHtml += loadHeading(key, filteredField);
              break;
            case 17:
              pioFieldHtml += loadDivider(key, filteredField);
              break;
            case 18:
              pioFieldHtml += loadSpacing(key, filteredField);
              break;
            case 19:
              pioFieldHtml += loadParagraph(key, filteredField);
              break;
            case 20:
              pioFieldHtml += loadHtmlCode(key, filteredField);
              break;
            case 21:
              pioFieldHtml += loadPopup(key, filteredField);
              break;
            default:
            // do Nothing
          }
        });
        return pioFieldHtml;
      };
      // Function to load option sets
      var pioLoadOptionSets = function (optionSets, settings) {
        var pioSetHtml = "";
        $pioobject.each(optionSets, function (key, optionset) {
          
          // Check validation
          if (pioValidateRule(optionset)) {
            console.log('optionset', optionset);
            pioSetHtml += pioLoadfields(optionset);
          }
        });
        // Total price message after all fields (shown only when total > 0)
        var initialTotalText = (typeof storeCurrency !== "undefined" && storeCurrency && typeof pioCurrencyConverter === "function")
          ? pioCurrencyConverter(storeCurrency, 0) : "0";
        pioSetHtml += '<div class="pio-options-total-price-wrapper" style="display:none;"><span class="pio-options-total-price-label">Selections will add <span class="pio-options-total-price-amount">' + initialTotalText + '</span> to the price.</span></div>';
        return pioSetHtml;
      };
      // Remembers what the theme may destroy on variant change so the options can be rebuilt.
      var pioReloadCache = null;
      var pioCacheRenderContext = function () {
        var pioProductTag = document.querySelector("[pio-product-data-json]");
        if (pioProductTag && pioProductTag.innerHTML && (!pioProductData || pioProductData == "")) {
          try {
            pioProductData = JSON.parse(pioProductTag.innerHTML);
          } catch (error) {}
        }
        var pioMarker = $pioobject(".pio-multiple-options").first();
        if (!pioMarker.length) {
          return;
        }
        pioReloadCache = {
          className: pioMarker.attr("class") || "pio-embedded-meta-json pio-multiple-options",
          productHandle: pioMarker.attr("data-phandle") || "",
          moneyFormat: pioMarker.attr("pio-format") || storeCurrency || ""
        };
      };
      // Rebuilds the container when the theme removed it (variant change) so pioHandler
      // can render the options again without the Liquid block being present.
      var pioEnsureContainer = function () {
        if ($pioobject(".pio-multiple-options").length) {
          return true;
        }
        var pioCache = pioReloadCache || {};
        var pioTarget = $pioobject("<div></div>")
          .attr("class", pioCache.className || "pio-embedded-meta-json pio-multiple-options")
          .attr("data-phandle", pioCache.productHandle || "")
          .attr("pio-format", pioCache.moneyFormat || storeCurrency || "");
        var pioWrapper = $pioobject(".pio-multiple-options-custom-wrapper").first();
        if (pioWrapper.length) {
          pioWrapper.append(pioTarget);
          return true;
        }
        var pioAddButton = $pioobject(
          "form button[name='add'], form input[name='add'], .pioAddToCart"
        ).first();
        if (!pioAddButton.length) {
          return false;
        }
        pioAddButton.parent().prepend(pioTarget);
        return true;
      };
      $pioobject.fn.pioHandler = function () {
        
        var pioJsonTag = document.querySelector("[pioembeddedjson]");
        var pioProductTag = document.querySelector("[pio-product-data-json]");
        if (typeof pioJsonTag != "undefined" && pioJsonTag != null) {
          
          pioJson = JSON.parse(pioJsonTag.innerHTML);
        }
        
        if (pioJson != "") {
          console.log('pioJson', pioJson)
          var pioSettings = pioJson.setting;
          storeCurrency = $pioobject(".pio-embedded-meta-json").attr("pio-format") || storeCurrency;
          plan_id = pioSettings?.plan_id || 1;

          // Initialize plan data from shop metadata after getting pioJson
          if (pioJson.shop && typeof handlePlansData === 'function') {
            var pioPlanData = handlePlansData(pioJson.shop.is_old_user, pioJson.shop.plan_tier);
            planTierValue = pioPlanData.planTierValue;
            isOldUserFlag = pioPlanData.isOldUserFlag;
          }
          
          pioLanguageSettings = pioJson;
          
          if (pioSettings.app_status) {
            if (pioSettings.custom_css != "") {
              pioAddCSS(pioSettings.custom_css);
            }
            // Load Offsets (only render option sets with status === 1)
            pioOptionSets = (pioJson.option_sets || []).filter(function (item) {
              return item.status == 1;
            });
            pioCacheRenderContext();
            pioEnsureContainer();
            var pioSetFields = pioLoadOptionSets(pioOptionSets, pioSettings);
            var pioExtEliment = $pioobject(".pio-multiple-options");
            var pioCustomEliment = $pioobject(".pio-multiple-options-custom-wrapper");
  
            if (pioCustomEliment.length > 0) {
              //pioCustomEliment.html(pioSetFields);
              pioCustomEliment.append(pioExtEliment);
              pioCustomEliment.append(pioJsonTag);
              pioCustomEliment.append(pioProductTag);
              $pioobject(".pio-multiple-options").html(pioSetFields);
              $pioobject(".pio-modal-overlay").appendTo("body");
              if (typeof pioUpdateTotalPriceMessage === "function") pioUpdateTotalPriceMessage();
              $pioobject(".pio-multiple-options").find(".pioDatePick").each(function () { pioUpdateDateDisplay($pioobject(this)); });
            } else {
              var pioFormFind = pioExtEliment.parent().parent().find("form button[name='add'], .pioAddToCart");
              pioFormFind.parent().prepend(pioExtEliment);
              pioFormFind.parent().prepend(pioJsonTag);
              pioFormFind.parent().prepend(pioProductTag);
              $pioobject(".pio-multiple-options").html(pioSetFields);
              $pioobject(".pio-modal-overlay").appendTo("body");
              if (typeof pioUpdateTotalPriceMessage === "function") pioUpdateTotalPriceMessage();
              $pioobject(".pio-multiple-options").find(".pioDatePick").each(function () { pioUpdateDateDisplay($pioobject(this)); });
            }
            $pioobject(
              "button[type=submit][name=add], .pioAddToCart"
            ).off("click.pioValidate").on("click.pioValidate", pioAddToCartValidation);
  
              // Bypass BuyNow Hook
              var pioBuyNowValidationStatus = 0;
              if ($pioobject.isFunction(window.pioBypassBuyNowValidation)) {
                  if (pioBypassBuyNowValidation(pioBuyNowValidationStatus)) {
                    pioBuyNowValidationStatus = pioBypassBuyNowValidation(pioBuyNowValidationStatus);
                  }
              }
              if(pioBuyNowValidationStatus == 0 && !document.getElementById("pioWrapper")){
                pioEnableBuyItNowButtonWrapper();  
              }
  
            //pioEnableBuyItNowButtonWrapper();
            if ($pioobject.isFunction(window.pioAfterLoadHook)) {
              pioAfterLoadHook();
            }
          }
        }
      };
      pioAddToCartValidation = function () {
        var pioFlag = pioFieldValidations();
        if (pioFlag == false) {
          return false;
        } else {
          return true;
        }
      };
      pioBuyItNowButtonValidation = function (event) {
        //event.stopImmediatePropagation();
        event.preventDefault();
        event.stopPropagation();
        var pioFlag = pioFieldValidations();
        if (pioFlag == false) {
          return false;
        } else {
          var pioBuyItNowButtonContainer = document.querySelector(
            '[class*="shopify-payment-button"]'
          );
          if (pioBuyItNowButtonContainer != null) {
            pioDisableBuyItNowButtonWrapper();
          }
        }
      };
      pioFieldValidations = function () {
        var pioFlag = true;
        $pioobject(".td-line-item-field").each(function () {
          // Input Text
          var $text = $pioobject(this).find(".pioShortText");
          if ($text.length) {
            var error = pioValidateTextField($text);
            pioRenderError($pioobject(this), error);
            if (error) {
              $text.addClass("pioError");
              pioFlag = false;
            } else {
              $text.removeClass("pioError");
            }
          }
          // Email
          var pioemail = $pioobject(this).find(".pioEmail");
          if (pioemail.length) {
            var error = "";
            if (!pioemail.val() && pioemail.attr("required")) {
              error = "This field is required";
              pioemail.addClass("pioError");
              pioFlag = false;
            } else {
              pioemail.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Colorpicker
          var piocolorpicker = $pioobject(this).find(".pioColorPicker");
          if (piocolorpicker.length) {
            var error = "";
            if (!piocolorpicker.val() && piocolorpicker.attr("required")) {
              error = "This field is required";
              piocolorpicker.addClass("pioError");
              pioFlag = false;
            } else {
              piocolorpicker.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Textarea
          var piotextarea = $pioobject(this).find("textarea");
          if (piotextarea.length) {
            var error = "";
            if (!piotextarea.val() && piotextarea.attr("required")) {
              error = "This field is required";
              piotextarea.addClass("pioError");
              pioFlag = false;
            } else {
              piotextarea.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Number
          var pionumber = $pioobject(this).find(".pioNumber");
          if (pionumber.length) {
            var error = "";
            if (!pionumber.val() && pionumber.attr("required")) {
              error = "This field is required";
              pionumber.addClass("pioError");
              pioFlag = false;
            } else {
              pionumber.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Datepicker
          var piodatepick = $pioobject(this).find(".pioDatePick");
          if (piodatepick.length) {
            var error = "";
            var isRange = piodatepick.hasClass("pioDatePick-start") || piodatepick.hasClass("pioDatePick-end");
            if (isRange) {
              var $startInput = $pioobject(this).find(".pioDatePick-start");
              var $endInput = $pioobject(this).find(".pioDatePick-end");
              if ($startInput.attr("required") && (!$startInput.val() || !$endInput.val())) {
                error = "This field is required";
                $startInput.addClass("pioError");
                $endInput.addClass("pioError");
                pioFlag = false;
              } else {
                $startInput.removeClass("pioError");
                $endInput.removeClass("pioError");
              }
            } else {
              if (!piodatepick.val() && piodatepick.attr("required")) {
                error = "This field is required";
                piodatepick.addClass("pioError");
                pioFlag = false;
              } else {
                piodatepick.removeClass("pioError");
              }
            }
            pioRenderError($pioobject(this), error);
          }
          // Image Upload
          var pioimage = $pioobject(this).find(".pioImage");
          if (pioimage.length) {
            var error = "";
            if (pioimage[0].files.length === 0 && pioimage.attr("required")) {
              error = "This field is required";
              pioimage.parent().addClass("pioError");
              pioimage.addClass("pioError");
              pioFlag = false;
            } else {
              pioimage.parent().removeClass("pioError");
              pioimage.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Phone
          var piophone = $pioobject(this).find(".pioPhone");
          if (piophone.length) {
            var error = "";
            if (!piophone.val() && piophone.attr("required")) {
              error = "This field is required";
              piophone.addClass("pioError");
              pioFlag = false;
            } else {
              piophone.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          //Select Box
          var pioselect = $pioobject(this).find("select");
          if (pioselect.length) {
            var error = "";
            if (!pioselect.val() && pioselect.attr("required")) {
              error = "This field is required";
              pioselect.addClass("pioError");
              pioFlag = false;
            } else {
              pioselect.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Button
          var piobutton = $pioobject(this).find(".pioButton");
          if (piobutton.length) {
            var error = "";
            var hasSelectedButton = $pioobject(this).find(".pioButton.pio-button-selected").length > 0;
            var isRequired = piobutton.first().hasClass("required");
            if (!hasSelectedButton && isRequired) {
              error = "This field is required";
              piobutton.addClass("pioError");
              pioFlag = false;
            } else {
              piobutton.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Image Swatch
          var pioimageswatch = $pioobject(this).find(".pioImageSwatch");
          if (pioimageswatch.length) {
            var error = "";
            var selectedSwatches = $pioobject(this).find(".pioImageSwatch.pio-swatch-selected");
            var currentSelection = selectedSwatches.length;
            var isRequired = pioimageswatch.first().hasClass("required");
            var minSelection = parseInt($pioobject(this).data("min")) || 0;
            var maxSelection = parseInt($pioobject(this).data("max")) || 999;
            
            if (isRequired && currentSelection === 0) {
              error = "This field is required";
              pioimageswatch.addClass("pioError");
              pioFlag = false;
            } else if (isRequired && (currentSelection < minSelection)) {
              error = "Please select at least " + minSelection + " option(s)";
              pioimageswatch.addClass("pioError");
              pioFlag = false;
            } else if (isRequired && (currentSelection > maxSelection)) {
              error = "Please select at most " + maxSelection + " option(s)";
              pioimageswatch.addClass("pioError");
              pioFlag = false;
            } else {
              pioimageswatch.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          //Checkbox Button: when field is required, at least one option must be selected (not each checkbox required)
          var piocheckbox = $pioobject(this).find(".pioCheckBox");
          if (piocheckbox.length) {
            var error = "";
            var pioTempData = [];
            var pioallValues = "";
            var checkboxGroupRequired = $pioobject(this).attr("data-checkbox-group-required") === "1" || $pioobject(this).hasClass("pio-checkbox-group-required");
            $pioobject(piocheckbox).each(function () {
              if ($pioobject(this).is(":checked")) {
                pioTempData.push($pioobject(this).attr("data-val"));
              }
            });
            pioallValues = pioTempData.toString();
            piocheckbox.val(pioallValues);
            var atLeastOneChecked = piocheckbox.filter(":checked").length > 0;
            if (!atLeastOneChecked && checkboxGroupRequired) {
              error = "This field is required";
              piocheckbox.addClass("pioError");
              pioFlag = false;
            } else {
              piocheckbox.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          // Color Swatch
          var piocolorswatch = $pioobject(this).find(".pioColorSwatch");
          if (piocolorswatch.length) {
            var error = "";
            var selectedSwatches = $pioobject(this).find(".pioColorSwatch.pio-swatch-selected");
            var currentSelection = selectedSwatches.length;
            var isRequired = piocolorswatch.first().hasClass("required");
            var minSelection = parseInt($pioobject(this).data("min")) || 0;
            var maxSelection = parseInt($pioobject(this).data("max")) || 999;
            
            if (isRequired && currentSelection === 0) {
              error = "This field is required";
              piocolorswatch.addClass("pioError");
              pioFlag = false;
            } else if (isRequired && (currentSelection < minSelection)) {
              error = "Please select at least " + minSelection + " option(s)";
              piocolorswatch.addClass("pioError");
              pioFlag = false;
            } else if (isRequired && (currentSelection > maxSelection)) {
              error = "Please select at most " + maxSelection + " option(s)";
              piocolorswatch.addClass("pioError");
              pioFlag = false;
            } else {
              piocolorswatch.removeClass("pioError");
            }
            pioRenderError($pioobject(this), error);
          }
          //Radio Button
          var pioradio = $pioobject(this).find('input[type="radio"]');
          if (pioradio.length) {
            var error = "";
            if (!pioradio.is(":checked") && pioradio.attr("required")) {
              error = "This field is required";
              $pioobject(this).find(".checkmark").addClass("pioRadioError");
              pioFlag = false;
            } else {
              $pioobject(this).find(".checkmark").removeClass("pioRadioError");
            }
            pioRenderError($pioobject(this), error);
          }
        });
        return pioFlag;
      };
      pioEnableBuyItNowButtonWrapper = function () {
        var pioBuyItNowButtonContainer = document.querySelector(
          '[class*="shopify-payment-button"]'
        );
        if (pioBuyItNowButtonContainer === null) {
          return;
        }
        var pioBuyInNowAWrapper = document.createElement("a");
        pioBuyInNowAWrapper.id = "pioWrapper";
        pioBuyInNowAWrapper.style.textDecoration = "none";
        pioBuyInNowAWrapper.href = "javascript:void(0);";
        //pioBuyInNowAWrapper.attr("onclick","pioBuyItNowButtonValidation(event)");
        pioBuyItNowButtonContainer.parentNode.insertBefore(
          pioBuyInNowAWrapper,
          pioBuyItNowButtonContainer
        );
        pioBuyInNowAWrapper.appendChild(pioBuyItNowButtonContainer);
        pioBuyItNowButtonContainer.style.pointerEvents = "none";
        var innerPaymentButton =
          pioBuyItNowButtonContainer.querySelector('[role="button"], [type="button"]') ||
          pioBuyItNowButtonContainer.firstElementChild;
        if (innerPaymentButton && typeof innerPaymentButton.setAttribute === "function") {
          innerPaymentButton.setAttribute("style", "pointer-events: none");
        }
      };
      pioDisableBuyItNowButtonWrapper = function () {
        var pioBuyInNowAWrapper = document.getElementById("pioWrapper");
        pioBuyInNowAWrapper.removeAttribute("href");
        pioBuyInNowAWrapper.style.pointerEvents = "auto";
        var pioBuyItNowButtonContainer = document.querySelector(
          '[class="shopify-payment-button"]'
        );
        pioBuyItNowButtonContainer.style.pointerEvents = "auto";
        var innerPaymentButton =
          pioBuyItNowButtonContainer.querySelector('[role="button"], [type="button"]') ||
          pioBuyItNowButtonContainer.firstElementChild;
        if (innerPaymentButton && typeof innerPaymentButton.setAttribute === "function") {
          innerPaymentButton.setAttribute("style", "pointer-events: auto");
        }
        if (
          document
            .querySelector('[class*="shopify-payment-button"]')
            .querySelector('[role="button"]') !== null
        ) {
          document
            .querySelector('[class*="shopify-payment-button"]')
            .querySelector('[role="button"]')
            .click();
        } else if (
          document
            .querySelector('[class*="shopify-payment-button"]')
            .querySelector('[type="button"]') !== null
        ) {
          document
            .querySelector('[class*="shopify-payment-button"]')
            .querySelector('[type="button"]')
            .click();
        }
      };
      pioAddCSS = function (pioCss) {
        var pioStyle = document.createElement("style");
        var pioHead = document.getElementsByTagName("head")[0];
        pioHead.appendChild(pioStyle);
        pioStyle.type = "text/css";
        if (pioStyle.styleSheet) {
          // This is required for IE8 and below.
          pioStyle.styleSheet.cssText = pioCss;
        } else {
          pioStyle.appendChild(document.createTextNode(pioCss));
        }
      };
      
      // Format date/time value for display according to date_format (1-9)
      // isoValue: "YYYY-MM-DD" or "YYYY-MM-DDTHH:mm" or "HH:mm"
      // formatId: "1"=Y-m-d, "2"=d-m-Y, "3"=m-d-Y, "4"=Y.m.d, "5"=d.m.Y, "6"=m.d.Y, "7"=Y/m/d, "8"=d/m/Y, "9"=m/d/Y
      function pioFormatDateValue(isoValue, formatId) {
        if (!isoValue || !isoValue.trim()) return "";
        var str = (isoValue + "").trim();
        formatId = String(formatId || "1");
        if (str.indexOf("T") !== -1) {
          var dtParts = str.split("T");
          return pioFormatDatePartOnly(dtParts[0], formatId) + " " + dtParts[1];
        }
        if (str.match(/^\d{1,2}:\d{2}/)) return str;
        return pioFormatDatePartOnly(str, formatId);
      }
      function pioFormatDatePartOnly(ymdStr, formatId) {
        var parts = (ymdStr || "").split("-");
        if (parts.length !== 3) return ymdStr;
        var y = parts[0], m = parts[1], d = parts[2];
        var formats = {
          "1": y + "-" + m + "-" + d,
          "2": d + "-" + m + "-" + y,
          "3": m + "-" + d + "-" + y,
          "4": y + "." + m + "." + d,
          "5": d + "." + m + "." + y,
          "6": m + "." + d + "." + y,
          "7": y + "/" + m + "/" + d,
          "8": d + "/" + m + "/" + y,
          "9": m + "/" + d + "/" + y
        };
        return formats[formatId] || formats["1"];
      }
      function pioDateDisplayPlaceholder(formatId, inputType) {
        var hints = { "1": "yyyy-mm-dd", "2": "dd-mm-yyyy", "3": "mm-dd-yyyy", "4": "yyyy.mm.dd", "5": "dd.mm.yyyy", "6": "mm.dd.yyyy", "7": "yyyy/mm/dd", "8": "dd/mm/yyyy", "9": "mm/dd/yyyy" };
        var hint = hints[String(formatId || "1")] || hints["1"];
        if (inputType === "time") return "hh:mm";
        if (inputType === "datetime-local") return hint + " hh:mm";
        return hint;
      }
      function pioUpdateDateDisplay($input) {
        var $wrap = $input.closest(".pio-date-input-wrap");
        if (!$wrap.length) return;
        var $display = $wrap.find(".pio-date-display");
        var val = ($input.val() || "").trim();
        var formatId = $input.attr("data-format") || $input.closest(".td-line-item-field").find(".pioDatePick").attr("data-format") || "1";
        if (val) {
          $display.text(pioFormatDateValue(val, formatId)).removeClass("pio-date-display--placeholder");
        } else {
          var inputType = $input.attr("type") || "date";
          $display.text($display.attr("data-placeholder") || pioDateDisplayPlaceholder(formatId, inputType)).addClass("pio-date-display--placeholder");
        }
      }

      // Helper function to generate help text HTML
      function generateHelpTextHtml(helpText, helpPos) {
        if (!helpText || helpText.trim() === "") {
          return "";
        }
        
        var helpPosStr = helpPos?.toString() || "1";
        var helpHtml = "";
        
        switch (helpPosStr) {
          case "1":
            // Below label
            helpHtml = '<small class="pio-help-text">' + helpText + "</small>";
            break;
          case "2":
            // Below whole field
            helpHtml = '<small class="pio-help-text">' + helpText + "</small>";
            break;
          case "3":
            // Above whole field
            helpHtml = '<small class="pio-help-text">' + helpText + "</small>";
            break;
          case "4":
            // Tooltip (custom styled: dark bg, white text, arrow)
            var escapedHelp = (helpText + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
            helpHtml = ' <span class="pio-tooltip-wrap"><span class="pio-tooltip"><svg fill="#000000" version="1.1" id="Capa_1" style="display: inline-block;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 416.979 416.979" xml:space="preserve"><g><path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/></g></svg></span><span class="pio-tooltip-content">' + escapedHelp + "</span></span>";
            break;
        }
        
        return helpHtml;
      }

      htmlToText = function (htmlString) {
        // Convert HTML to plain text
        return htmlString
          // Replace <br> and <p> with line breaks
          ?.replace(/<br\s*\/?>/gi, "\n")
          ?.replace(/<\/p>/gi, "\n")
          // Strip all remaining HTML tags
          ?.replace(/<[^>]+>/g, "")
          // Decode HTML entities (e.g. &amp; → &)
          ?.replace(/&nbsp;/g, " ")
          ?.replace(/&amp;/g, "&")
          ?.replace(/&lt;/g, "<")
          ?.replace(/&gt;/g, ">")
          ?.replace(/&quot;/g, '"')
          ?.replace(/&#039;/g, "'");
      }

      escapeHtmlText = function (value) {
        return String(value == null ? "" : value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#039;");
      }

      sanitizeClassName = function (value) {
        return htmlToText(value || "")
          .replace(/[^\w\- ]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();
      }

      htmlToText = function (htmlString) {
        var text = String(htmlString == null ? "" : htmlString)
          .replace(/<br\s*\/?>/gi, "\n")
          .replace(/<\/p>/gi, "\n");

        for (var i = 0; i < 2; i++) {
          text = text
            .replace(/&nbsp;/g, " ")
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#039;/g, "'")
            .replace(/<[^>]+>/g, "");
        }

        return text;
      }
      
      loadTextBox = function (key, field) {
        console.log("Text Box", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldPlaceholder = htmlToText(pioloadLanguage(key, field, "placeholder"));
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        pioFieldPlaceholder = pioFieldPlaceholder ? pioFieldPlaceholder : "";
        var pioFieldPlaceholderHtml = escapeHtmlText(pioFieldPlaceholder);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        if (field.required) {
          isRequiredClass = "required";
        }
        if (field.placeholder == null) {
          field.placeholder = "";
        }
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        var defaultValue = htmlToText(field.default_value || "");
        var defaultValueAttr = escapeHtmlText(defaultValue);
        var defaultSubmitValue = defaultValue;
        if (defaultValue && pioFieldPrice) {
          defaultSubmitValue = defaultValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }

        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '"' + ' style="width:' + (field.column_width || "100") + '%;" ' + 
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content"><input ' +
          isRequiredClass +
          ' class="pioShortText ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr +
          '" type="text" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '"  placeholder="' + pioFieldPlaceholderHtml + '" ' +
          ' value="' + defaultValueAttr + '" ' +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          ' data-allowed="' + escapeHtmlText(field.allowed_value || "1") + '" ' +
          ' data-transform="' + escapeHtmlText(field.text_transform || "1") + '" '+
          ' minlength="' + escapeHtmlText(field.min_character || "") + '" ' +
          ' maxlength="' + escapeHtmlText(field.max_character || "") + '" ' +
          ' data-show-counter="' + escapeHtmlText(field.show_character_counter || "") + '" ' +
          '>' +
          "<input " +
          isRequiredClass +
          ' class="pioShortText__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '"' + ' value="' + escapeHtmlText(defaultSubmitValue) + '" ' + '></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadEmail = function (key, field) {
        console.log("Email", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldPlaceholder = htmlToText(pioloadLanguage(key, field, "placeholder"));
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        pioFieldPlaceholder = pioFieldPlaceholder ? pioFieldPlaceholder : "";
        var pioFieldPlaceholderHtml = escapeHtmlText(pioFieldPlaceholder);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        
        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.placeholder == null) {
          field.placeholder = "";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        var defaultValue = htmlToText(field.default_value || "");
        var defaultValueAttr = escapeHtmlText(defaultValue);
        var defaultSubmitValue = defaultValue;
        if (defaultValue && pioFieldPrice) {
          defaultSubmitValue = defaultValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content"><input ' +
          isRequiredClass +
          ' class="pioEmail ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr +
          '" type="email" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '" placeholder="' + pioFieldPlaceholderHtml + '" ' +
          ' value="' + defaultValueAttr + '" ' +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          '>' +
          "<input " +
          isRequiredClass +
          ' class="pioEmail__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(defaultSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadColorPicker = function (key, field) {
        console.log("Color Picker", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        var defaultValue = field.default_value || "";
        
        // Validate default_value is a valid hex color
        if (defaultValue && !defaultValue.match(/^#[0-9A-Fa-f]{6}$/)) {
          defaultValue = "#000000";
        }
        
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        
        if (parseInt(field.required)) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        var defaultValueAttr = escapeHtmlText(defaultValue);
        var defaultSubmitValue = defaultValue;
        if (defaultValue && pioFieldPrice) {
          defaultSubmitValue = defaultValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          field.html_class +
          '" style="width:100%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (parseInt(field.required) ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content">' +
          '<input ' + isRequiredClass +
          ' class="pioColorPicker ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr +
          '" type="color" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '" value="' + defaultValueAttr + '" ' +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          '>' +
          "<input " + isRequiredClass +
          ' class="pioColorPicker__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(defaultSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadTextArea = function (key, field) {
        console.log("Textarea", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldPlaceholder = htmlToText(pioloadLanguage(key, field, "placeholder"));
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        pioFieldPlaceholder = pioFieldPlaceholder ? pioFieldPlaceholder : "";
        var pioFieldPlaceholderHtml = escapeHtmlText(pioFieldPlaceholder);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        if (field.required) {
          isRequiredClass = "required";
        }
        if (field.placeholder == null) {
          field.placeholder = "";
        }
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        var defaultValue = htmlToText(field.default_value || "");
        var defaultValueHtml = escapeHtmlText(defaultValue);
        var defaultSubmitValue = defaultValue;
        if (defaultValue && pioFieldPrice) {
          defaultSubmitValue = defaultValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '"' + ' style="width:' + (field.column_width || "100") + '%;" ' + 
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content"><textarea ' +
          isRequiredClass +
          ' class="pioLongText ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr + '" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '" placeholder="' + pioFieldPlaceholderHtml + '"' +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          ' data-allowed="' + escapeHtmlText(field.allowed_value || "1") + '" ' +
          ' data-transform="' + escapeHtmlText(field.text_transform || "1") + '" ' +
          ' minlength="' + escapeHtmlText(field.min_character || "") + '" ' +
          ' maxlength="' + escapeHtmlText(field.max_character || "") + '" ' +
          ' data-show-counter="' + escapeHtmlText(field.show_character_counter || "") + '" ' +
          '>' + defaultValueHtml + '</textarea><input ' +
          isRequiredClass +
          ' class="pioLongText__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '"' + ' value="' + escapeHtmlText(defaultSubmitValue) + '" ' + '></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadSwitch = function (key, field) {
        console.log("Switch", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var pioFieldPrice = field.addon_price;
        var isChecked = parseInt(field.selected_by_default) ? " checked" : "";
        var switchValue = parseInt(field.selected_by_default) ? "Yes" : "";
        
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var switchSubmitValue = switchValue;
        if (switchValue && pioFieldPrice) {
          switchSubmitValue = switchValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content pio-switch-wrapper">' +
          '<label class="pio-switch">' +
          '<input type="checkbox" ' +
          ' class="pioSwitch' +
          '" id="' + pioFieldCartNameAttr +
          '" name="' + pioFieldCartNameAttr +
          '" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '"' + isChecked +
          '>' +
          '<span class="pio-switch-slider"></span>' +
          '</label>' +
          '<input class="pioSwitch__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(switchSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadNumber = function (key, field) {
        console.log("Number", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldPlaceholder = htmlToText(pioloadLanguage(key, field, "placeholder"));
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        pioFieldPlaceholder = pioFieldPlaceholder ? pioFieldPlaceholder : "";
        var pioFieldPlaceholderHtml = escapeHtmlText(pioFieldPlaceholder);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        
        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.placeholder == null) {
          field.placeholder = "";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        var defaultValue = htmlToText(field.default_value || "");
        var defaultValueAttr = escapeHtmlText(defaultValue);
        var defaultSubmitValue = defaultValue;
        if (defaultValue && pioFieldPrice) {
          defaultSubmitValue = defaultValue + " |" + pioCurrencyConverter(storeCurrency, pioFieldPrice);
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content"><input ' +
          isRequiredClass +
          ' class="pioNumber ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr +
          '" type="number" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '" placeholder="' + pioFieldPlaceholderHtml + '" ' +
          ' value="' + defaultValueAttr + '" ' +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          ' min="' + escapeHtmlText(field.min_character !== undefined && field.min_character !== null && field.min_character !== "" ? field.min_character : 0) + '" ' +
          ' max="' + escapeHtmlText(field.max_character || "") + '" ' +
          '>' +
          "<input " +
          isRequiredClass +
          ' class="pioNumber__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(defaultSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadDatepicker = function (key, field) {
        console.log("Date Picker", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);

        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }

        var inputType = "date";
        if (field.format == "2") {
          inputType = "time";
        } else if (field.format == "3") {
          inputType = "datetime-local";
        }

        var mode = field.mode || "1";
        
        var dateInputHtml = "";
        var hiddenInputHtml = "";

        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";

        if (mode == "2") {
          var dateFormatId = (field.date_format || "1");
          var phStart = pioDateDisplayPlaceholder(dateFormatId, inputType);
          var phEnd = phStart;
          dateInputHtml += 
            '<div class="pio-date-range-wrapper">' +
            '<div class="pio-date-input-wrap">' +
            '<span class="pio-date-display pio-date-display--placeholder" data-placeholder="' + escapeHtmlText(phStart) + '">' + escapeHtmlText(phStart) + '</span>' +
            '<span class="pio-date-calendar-icon" aria-hidden="true"></span>' +
            '<input type="' + inputType + '" ' +
            isRequiredClass +
            ' class="pioDatePick pioDatePick-start ' + isRequiredClass +
            '" id="' + pioFieldCartNameAttr + '_start" ' +
            'name="' + pioFieldCartNameAttr + '_start" ' +
            'pio-price="' + escapeHtmlText(pioFieldPrice) + '" ' +
            'data-format="' + escapeHtmlText(dateFormatId) + '" ' +
            'data-help="' + helpTextSafe + '" ' +
            'data-help-pos="' + helpPos + '" ' +
            'value="' + '">' +
            '</div>' +
            '<span class="pio-date-range-separator"> to </span>' +
            '<div class="pio-date-input-wrap">' +
            '<span class="pio-date-display pio-date-display--placeholder" data-placeholder="' + escapeHtmlText(phEnd) + '">' + escapeHtmlText(phEnd) + '</span>' +
            '<span class="pio-date-calendar-icon" aria-hidden="true"></span>' +
            '<input type="' + inputType + '" ' +
            isRequiredClass +
            ' class="pioDatePick pioDatePick-end ' + isRequiredClass +
            '" id="' + pioFieldCartNameAttr + '_end" ' +
            'name="' + pioFieldCartNameAttr + '_end" ' +
            'pio-price="' + escapeHtmlText(pioFieldPrice) + '" ' +
            'data-format="' + escapeHtmlText(dateFormatId) + '" ' +
            'value="' + '">' +
            '</div>' +
            '</div>';
          
          hiddenInputHtml = 
            '<input class="pioDatePick__original" id="' +
            pioFieldCartNameAttr +
            '_original" type="hidden" name="properties[' +
            pioFieldCartNameAttr +
            ']" pio-price="' +
            escapeHtmlText(pioFieldPrice) +
            '" value="' + '">';
        } else {
          var dateFormatId = (field.date_format || "1");
          var ph = pioDateDisplayPlaceholder(dateFormatId, inputType);
          dateInputHtml = 
            '<div class="pio-date-input-wrap">' +
            '<span class="pio-date-display pio-date-display--placeholder" data-placeholder="' + escapeHtmlText(ph) + '">' + escapeHtmlText(ph) + '</span>' +
            '<span class="pio-date-calendar-icon" aria-hidden="true"></span>' +
            '<input type="' + inputType + '" ' +
            isRequiredClass +
            ' class="pioDatePick ' + isRequiredClass +
            '" id="' +
            pioFieldCartNameAttr +
            '" name="' +
            pioFieldCartNameAttr +
            '" pio-price="' +
            escapeHtmlText(pioFieldPrice) +
            '" ' +
            'data-format="' + escapeHtmlText(dateFormatId) + '" ' +
            'data-help="' + helpTextSafe + '" ' +
            'data-help-pos="' + helpPos + '" ' +
            'value="' + '">' +
            '</div>';
          
          hiddenInputHtml = 
            '<input class="pioDatePick__original" id="' +
            pioFieldCartNameAttr +
            '_original" type="hidden" name="properties[' +
            pioFieldCartNameAttr +
            ']" pio-price="' +
            escapeHtmlText(pioFieldPrice) +
            '" value="' + '">';
        }
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content">' +
          dateInputHtml +
          hiddenInputHtml +
          "</span>" +
          helpTextAtEnd +
          "</div>"
        );
      };
      loadImageUpload = function (key, field) {
        console.log("Image Upload", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;

        // Calculate max files based on conditions
        var maxFiles = 10; // Default 10
        // if (isOldUserFlag === true) {
        //   maxFiles = 5;
        // } else if (isOldUserFlag === false) {
        //   if (planTierValue == 2) {
        //     maxFiles = 10;
        //   } else if (planTierValue == 3) {
        //     maxFiles = 20;
        //   }
        // }
        
        if (
          pioFieldPrice != "" &&
          pioFieldPrice != null &&
          parseFloat(pioFieldPrice) > 0
        ) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        
        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        
        // Handle allow_multiple flag
        var multipleAttr = "";
        if (isOldUserFlag === true) {
          multipleAttr = ""; // Old users cannot have multiple uploads
        }
        else {
          if (field.allow_multiple) {
            multipleAttr = " multiple";
          }
        }

        // We use the hidden __original input to submit the combined filename list (and price),
        // so the visible file input must NOT submit to properties[*] (otherwise Shopify keeps only the last file).
        var fileInputNameAttr = "";
        
        // Handle allowed_extensions - apply restrictions based on user plan
        var allowedExtensions = [];
        var acceptAttr = "";
        
        // Define allowed extension lists for different tiers
        var tier1AllowedExtensions = [".jpg", ".jpeg", ".png"];
        var tier2AllowedExtensions = [".bmp", ".gif", ".heic", ".jpg", ".jpeg", ".png", ".tif", ".webp"];
        
        // Normalize field extensions (ensure they have dot prefix)
        var fieldExtensions = [];
        if (field.allowed_extensions && Array.isArray(field.allowed_extensions) && field.allowed_extensions.length > 0) {
          fieldExtensions = field.allowed_extensions.map(function(ext) {
            return ext.startsWith('.') ? ext.toLowerCase() : '.' + ext.toLowerCase();
          });
        }
        
        // Apply restrictions based on user plan
        if (isOldUserFlag === true) {
          // Old user: filter to only jpg/png/jpeg if they exist in field.allowed_extensions
          allowedExtensions = fieldExtensions.filter(function(ext) {
            return tier1AllowedExtensions.indexOf(ext) !== -1;
          });
        } else if (isOldUserFlag === false) {
          if (planTierValue == 1) {
            // Tier 1: filter to only jpg/png/jpeg if they exist in field.allowed_extensions
            allowedExtensions = fieldExtensions.filter(function(ext) {
              return tier1AllowedExtensions.indexOf(ext) !== -1;
            });
          } else if (planTierValue == 2) {
            // Tier 2: filter to only tier2AllowedExtensions if they exist in field.allowed_extensions
            allowedExtensions = fieldExtensions.filter(function(ext) {
              return tier2AllowedExtensions.indexOf(ext) !== -1;
            });
          } else if (planTierValue == 3) {
            // Tier 3: use all field.allowed_extensions without restrictions
            allowedExtensions = fieldExtensions;
          }
        }
        
        // If no extensions match the restrictions, use empty array (will allow all)
        // Or you could default to tier1AllowedExtensions if needed
        if (allowedExtensions.length === 0 && fieldExtensions.length > 0) {
          // If field has extensions but none match restrictions, use empty (no accept attribute)
          allowedExtensions = [];
        }
        
        // Build accept attribute
        if (allowedExtensions.length > 0) {
          acceptAttr = ' accept="' + escapeHtmlText(allowedExtensions.join(",")) + '"';
        }

        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '" ' +
          'data-allowed-extensions="' + escapeHtmlText(field.allowed_extensions ? JSON.stringify(field.allowed_extensions) : "") + '" ' +
          ">" +
          helpTextAtStart +
          '<label class="td-label" for="' + pioFieldCartNameAttr + '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          "</label>" +
          helpTextAfterLabel +
          '<span class="td-content">' +
          '<div class="pio-file-wrapper">' +
          '<div class="pio-file-dropzone">' +
          '<span class="pio-file-button">Choose file</span>' +
          '<span class="pio-file-help">or drop file to upload</span>' +
          '<input type="file" ' + isRequiredClass +
          ' class="pioImage ' + isRequiredClass +
          '" id="' + pioFieldCartNameAttr +
          '"' +
          fileInputNameAttr +
          ' pio-price="' + escapeHtmlText(pioFieldPrice) + '"' +
          multipleAttr + acceptAttr +
          ' data-help="' + helpTextSafe + '" ' +
          ' data-help-pos="' + helpPos + '" ' +
          ' data-max-files="' + escapeHtmlText(maxFiles) + '" ' +
          ">" +
          "</div>" +
          '<div class="pio-file-inputs"></div>' +
          '<input class="pioImage__original" id="' +
          pioFieldCartNameAttr + '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr + ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) + '" value="">' +
          "</div>" +
          "</span>" +
          helpTextAtEnd +
          "</div>"
        );
      };
      loadPhone = function (key, field) {
        console.log("Phone", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
      
        var isRequiredClass = "";
        var pioFieldPrice = field.addon_price;
      
        var placeholder = htmlToText(pioloadLanguage(key, field, "placeholder") || field.placeholder || "");
        var placeholderHtml = escapeHtmlText(placeholder);
        var defaultCountry = (field.default_country || "91").toString().replace(/[^\d]/g, "");
        var htmlClass = sanitizeClassName(field.html_class || "");
      
        if (pioFieldPrice != "" && pioFieldPrice != null && parseFloat(pioFieldPrice) > 0) {
          var priceLabel = pioCurrencyConverter(storeCurrency, pioFieldPrice);
          pioFieldLabel = pioFieldLabel + " (+" + priceLabel + ")";
        } else {
          pioFieldPrice = "";
        }
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
      
        if (field.required) {
          isRequiredClass = "required";
        }
      
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          htmlClass +
          '" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content">' +
          '<div class="pio-phone-wrapper">' +
          '<span class="pio-phone-prefix">+</span>' +
          '<input type="text" inputmode="numeric" pattern="[0-9]*" ' +
          'class="pioPhoneCountry ' + isRequiredClass + '" ' +
          'value="' + escapeHtmlText(defaultCountry) + '" ' +
          'data-role="country" />' +
          '<input ' + isRequiredClass +
          ' class="pioPhone ' + isRequiredClass + '" ' +
          'id="' + pioFieldCartNameAttr + '" ' +
          'type="tel" inputmode="tel" ' +
          'placeholder="' + placeholderHtml + '" ' +
          'pio-price="' + escapeHtmlText(pioFieldPrice) + '" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '" ' +
          '>' +
          '</div>' +
          '<input class="pioPhone__original" id="' +
          pioFieldCartNameAttr + '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr + ']" pio-price="' + escapeHtmlText(pioFieldPrice) +
          '" value="">' +
          '</span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadSelectBox = function (key, field) {
        console.log("Select", field);
        var options = field.option_values;
        var isRequiredClass = "";
        var isMultipleClass = "";
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var pioFieldPlaceholder = htmlToText(pioloadLanguage(key, field, "placeholder"));
        var pioFieldPlaceholderHtml = escapeHtmlText(pioFieldPlaceholder);
        pioFieldPlaceholder = pioFieldPlaceholder ? pioFieldPlaceholder : "";
        var selectHtml = pioFieldPlaceholder ? '<option value="" disabled ' + (!field.default_value ? "selected" : "") + '>' + pioFieldPlaceholderHtml + "</option>" : '<option value="" disabled ' + (!field.default_value ? "selected" : "") + '>' + pioFieldLabelHtml + "</option>";
        if (field.required) {
          isRequiredClass = "required";
        }
        if (field.allow_multiple) {
          isMultipleClass = "multiple";
        }
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        var pioPrice = "";
        var pioSelectedFirst = "";
        for (var i = 0; i < options?.length; i++) {
          var optLabel = options[i].label;
          var optLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optLabel)) : htmlToText(optLabel);
          var optLabelDisplaySafe = escapeHtmlText(optLabelDisplay);
          if (optLabelDisplay == null || optLabelDisplay == undefined) {
            continue;
          }
          if(field.default_value == optLabel){
            pioPrice = options[i].price;
            pioSelectedFirst = (optLabelDisplay != null && optLabelDisplay != undefined) ? htmlToText(optLabelDisplay) : "";
          }
          selectHtml += '<option value="' +
            ((optLabelDisplay != null && optLabelDisplay != undefined) ? optLabelDisplaySafe : "") +
            '" ' +
            (field.default_value == optLabel ? "selected" : "") +
            ' data-price="' +
            escapeHtmlText(options[i].price || "") +
            '">' +
            ((optLabelDisplay != null && optLabelDisplay != undefined) ? optLabelDisplaySafe : "") +
            (parseFloat(options[i].price) > 0
              ? " (+" +
                escapeHtmlText(pioCurrencyConverter(storeCurrency, options[i].price)) +
                ")"
              : "") +
            "</option>";
        }
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content"><select placeholder="' +
          pioFieldPlaceholderHtml +
          '" ' +
          isRequiredClass +
          isMultipleClass +
          ' class="pioSelect ' + isRequiredClass + isMultipleClass +
          '" id="' + pioFieldCartNameAttr + '" name="' + pioFieldCartNameAttr + '" ' +
          'data-help="' + helpTextSafe +
          '" ' +
          'data-help-pos="' + helpPos +
          '" ' +
          'data-placeholder="' + pioFieldPlaceholderHtml +
          '" ' +
          'data-default="' + escapeHtmlText(pioSelectedFirst) +
          '" ' +
          '>' + selectHtml + '</select><input class="' +
          'pioSelect__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioPrice) +
          '" value="' +
          escapeHtmlText(pioSelectedFirst) +
          '">' +
          "</span>" +
          helpTextAtEnd +
          "</div>"
        );
      };
      loadButton = function (key, field) {
        console.log("Button", field);
        var options = field.option_values;
        var isRequiredClass = "";
        var isMultipleClass = "";
        var buttonHtml = "";
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var defaultValue = field.default_value || "";
        var allowMultiple = field.allow_multiple ? true : false;

        if (allowMultiple) {
          isMultipleClass = "multiple";
        }

        var pioFieldPrice = "";
        var pioSelectedFirst = "";

        if (field.required) {
          isRequiredClass = "required";
        }

        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);

        if (field.column_width == null) {
          field.column_width = "100";
        }

        for (var i = 0; i < options?.length; i++) {
          var optLabel = options[i].label;
          var optLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optLabel)) : htmlToText(optLabel);
          var optLabelDisplaySafe = escapeHtmlText(optLabelDisplay);
          if (optLabelDisplay == null || optLabelDisplay == undefined) {
            continue;
          }

          var piooptionPrice = "";
          var piooptionPriceLabel = "";
          var isSelected = defaultValue === optLabel ? " pio-button-selected" : "";

          if (defaultValue == optLabel) {
            pioFieldPrice = options[i].price || "";
            pioSelectedFirst = optLabelDisplay;
          }

          if (parseFloat(options[i].price) > 0) {
            piooptionPrice = options[i].price;
            piooptionPriceLabel = " (+" + escapeHtmlText(pioCurrencyConverter(storeCurrency, options[i].price)) + ")";
          } else {
            piooptionPrice = "";
            piooptionPriceLabel = "";
          }

          buttonHtml +=
            '<button type="button" ' +
            'class="pioButton ' + isRequiredClass + isMultipleClass + isSelected +
            '" data-value="' + optLabelDisplaySafe +
            '" data-label="' + optLabelDisplaySafe +
            '" data-price="' + escapeHtmlText(piooptionPrice) +
            '" data-index="' + i +
            '">' +
            optLabelDisplaySafe +
            piooptionPriceLabel +
            '</button>';
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '" ' +
          'data-default="' + escapeHtmlText(pioSelectedFirst) + '" ' +
          'data-multiple="' + (allowMultiple ? "1" : "0") + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content pio-button-group">' +
          buttonHtml +
          '<input class="pioButton__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(pioSelectedFirst) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadImageSwatch = function (key, field) {
        console.log("Image Swatch", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var isRequiredClass = "";
        var allowMultiple = field.allow_multiple ? true : false;
        var minSelection = parseInt(field.min_selection) || 0;
        var maxSelection = parseInt(field.max_selection) || 999;
        var swatchImageWidth = field.swatch_image_width || 30;
        var swatchImageHeight = field.swatch_image_height || 30;
        var swatchStyle = field.swatch_style || "1";
        var tooltipStyle = parseInt(field.tooltip_style) || 0;
        
        // Use option_values array structure
        var optionsArray = [];
        var priceArray = [];
        var imageArray = [];
        
        if (field.option_values && Array.isArray(field.option_values) && field.option_values.length > 0) {
          for (var i = 0; i < field.option_values.length; i++) {
            optionsArray.push(field.option_values[i].label);
            priceArray.push(field.option_values[i].price || "");
            imageArray.push(field.option_values[i].image || "");
          }
        }

        // Handle default_value
        var defaultValue = field.default_value || "";

        if (parseInt(field.required)) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        
        var swatchHtml = "";
        var pioSelectedFirst = "";
        var pioSelectedPrice = "";
        var pioSelectedSubmitValue = "";
        for (var i = 0; i < optionsArray.length; i++) {
          var optionLabel = optionsArray[i];
          var optionLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optionLabel)) : htmlToText(optionLabel);
          var optionLabelDisplaySafe = escapeHtmlText(optionLabelDisplay);
          var optionImage = imageArray[i];
          var optionImageSafe = escapeHtmlText(optionImage);
          var optionPrice = priceArray[i] || "";
          var isSelected = defaultValue === optionLabel ? " pio-swatch-selected" : "";
          if (defaultValue === optionLabel) {
            pioSelectedFirst = optionLabelDisplay;
            pioSelectedPrice = optionPrice;
            if (parseFloat(optionPrice) > 0) {
              pioSelectedSubmitValue = optionLabelDisplay + " |" + pioCurrencyConverter(storeCurrency, optionPrice);
            } else {
              pioSelectedSubmitValue = optionLabelDisplay;
            }
          }
          
          var priceLabel = "";
          if (parseFloat(optionPrice) > 0) {
            var priceWithCurrency = pioCurrencyConverter(storeCurrency, optionPrice);
            priceLabel = " (+" + escapeHtmlText(priceWithCurrency) + ")";
          }
          
          var tooltipHtml = "";
          if (tooltipStyle == 1) {
            var tooltipText = (optionLabelDisplay + priceLabel + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
            tooltipHtml = '<span class="pio-swatch-tooltip">' + tooltipText + "</span>";
          }
          
          swatchHtml +=
            '<button type="button" ' +
            'class="pioImageSwatch ' + isRequiredClass + isSelected +
            '" data-value="' + optionLabelDisplaySafe +
            '" data-price="' + escapeHtmlText(optionPrice) +
            '" data-index="' + i +
            '">' +
            tooltipHtml +
            (optionImage ? '<img src="' + optionImageSafe + '" alt="' + optionLabelDisplaySafe + '" style="width:' + swatchImageWidth + 'px; height:' + swatchImageHeight + 'px; object-fit: cover;">' : '<span>' + optionLabelDisplaySafe + '</span>') +
            '</button>';
        }
        
        var swatchContainerClass = "pio-swatch-container";
        if (swatchStyle == "2") {
          swatchContainerClass += " pio-swatch-vertical";
        } else {
          swatchContainerClass += " pio-swatch-horizontal";
        }
        
        // Build selected value div only if default value exists (option-wise price)
        var selectedValueDiv = "";
        if (defaultValue && defaultValue.trim() !== "") {
          var displayPartsImg = [];
          for (var di = 0; di < optionsArray.length; di++) {
            if (defaultValue === optionsArray[di]) {
              var optPrice = parseFloat(priceArray[di]) || 0;
              var part = typeof pioGetTranslatedOptionLabel === "function"
                ? htmlToText(pioGetTranslatedOptionLabel(field, optionsArray[di]))
                : htmlToText(optionsArray[di]);
              if (optPrice > 0) {
                part += " (+" + pioCurrencyConverter(storeCurrency, optPrice) + ")";
              }
              displayPartsImg.push(part);
            }
          }
          var displayValue = escapeHtmlText(displayPartsImg.join(", "));
          selectedValueDiv = '<div class="pio-selected-value" id="' + pioFieldCartNameAttr + '_selected">' + displayValue + '</div>';
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '" ' +
          'data-multiple="' + (allowMultiple ? "1" : "0") + '" ' +
          'data-min="' + minSelection + '" ' +
          'data-max="' + maxSelection + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (parseInt(field.required) ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          selectedValueDiv +
          '<span class="td-content">' +
          '<div class="' + swatchContainerClass + '">' +
          swatchHtml +
          '</div>' +
          '<input class="pioImageSwatch__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' + escapeHtmlText(pioSelectedPrice) + '" value="' + escapeHtmlText(pioSelectedSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadCheckBox = function (key, field) {
        console.log("Checkbox", field);
        var isRequiredClass = "";
        var CheckBoxHtml = "";
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        
        // Use new option_values array structure
        var optionsArray = [];
        var priceArray = [];
        
        if (field.option_values && Array.isArray(field.option_values) && field.option_values.length > 0) {
          for (var i = 0; i < field.option_values.length; i++) {
            optionsArray.push(field.option_values[i].label);
            priceArray.push(field.option_values[i].price || "");
          }
        }

        // Handle single default_value
        var defaultValue = field.default_value || "";
        
        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }

        var pioFieldPrice = "";
        var pioSelectedFirst = "";
        var pioSelectedSubmitValue = "";
        for (var i = 0; i < optionsArray.length; i++) {
          var piooptionPrice = "";
          var piooptionPriceLabel = "";
          var optionLabel = optionsArray[i];
          var optionLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optionLabel)) : htmlToText(optionLabel);
          var optionLabelDisplaySafe = escapeHtmlText(optionLabelDisplay);
          var optionInputId = escapeHtmlText(optionLabelDisplay + "_" + pioFieldCartName);
          var isChecked = (defaultValue === optionLabel) ? " checked" : "";
          if(defaultValue == optionsArray[i]){
            piooptionPrice = priceArray[i];
            pioFieldPrice = piooptionPrice;
            pioSelectedFirst = optionLabelDisplay;
            if (parseFloat(piooptionPrice) > 0) {
              var defaultPriceLabel = pioCurrencyConverter(storeCurrency, piooptionPrice);
              pioSelectedSubmitValue = optionLabelDisplay + " |" + defaultPriceLabel;
            } else {
              pioSelectedSubmitValue = optionLabelDisplay;
            }
          }else{
            piooptionPrice = "";
          }
          if (parseFloat(priceArray[i]) > 0) {
            piooptionPrice = priceArray[i];
            var priceLabel = pioCurrencyConverter(storeCurrency, piooptionPrice);
            piooptionPriceLabel = " (+" + escapeHtmlText(priceLabel) + ")";
          } else {
            piooptionPrice = "";
            piooptionPriceLabel = "";
          }
          
          CheckBoxHtml +=
            '<div class="pio-checkbox-option">' +
            '<label class="pioCheckboxLabel" for="' +
            optionInputId +
            '"><input type="checkbox" ' +
            ' class="pioCheckBox' +
            '" id="' +
            optionInputId +
            '" name="' +
            pioFieldCartNameAttr +
            '" data-val="' +
            optionLabelDisplaySafe +
            '" value="' +
            optionLabelDisplaySafe +
            '" pio-price="' +
            escapeHtmlText(piooptionPrice) +
            '"' + isChecked +
            '><span class="checkmark checkmark--checkbox"></span>' +
            optionLabelDisplaySafe +
            piooptionPriceLabel +
            "</label>" +
            '</div>';
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          " pio-checkbox-" +
          key +
          (field.required ? " pio-checkbox-group-required" : "") +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          (field.required ? ' data-checkbox-group-required="1"' : '') +
          ' data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content">' +
          CheckBoxHtml +
          '<input class="pioCheckBox__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(pioSelectedSubmitValue) + '"></input>' +
          "</span>" +
          helpTextAtEnd +
          "</div>"
        );
      };
      loadColorSwatch = function (key, field) {
        console.log("Color Swatch", field);
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        var isRequiredClass = "";
        var allowMultiple = field.allow_multiple ? true : false;
        var minSelection = parseInt(field.min_selection) || 0;
        var maxSelection = parseInt(field.max_selection) || 999;
        var swatchColorWidth = field.swatch_color_width || 30;
        var swatchColorHeight = field.swatch_color_height || 30;
        var swatchStyle = field.swatch_style || "1";
        var tooltipStyle = parseInt(field.tooltip_style) || 0;
        
        // Use option_values array structure
        var optionsArray = [];
        var priceArray = [];
        var colorArray = [];
        
        if (field.option_values && Array.isArray(field.option_values) && field.option_values.length > 0) {
          for (var i = 0; i < field.option_values.length; i++) {
            optionsArray.push(field.option_values[i].label);
            priceArray.push(field.option_values[i].price || "");
            colorArray.push(field.option_values[i].color || "#000000");
          }
        }

        // Handle default_value
        var defaultValue = field.default_value || "";

        if (parseInt(field.required)) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }
        
        var swatchHtml = "";
        var pioSelectedFirst = "";
        var pioSelectedPrice = "";
        var pioSelectedSubmitValue = "";
        for (var i = 0; i < optionsArray.length; i++) {
          var optionLabel = optionsArray[i];
          var optionLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optionLabel)) : htmlToText(optionLabel);
          var optionLabelDisplaySafe = escapeHtmlText(optionLabelDisplay);
          var optionColor = colorArray[i];
          var optionPrice = priceArray[i] || "";
          var isSelected = defaultValue === optionLabel ? " pio-swatch-selected" : "";
          if (defaultValue === optionLabel) {
            pioSelectedFirst = optionLabelDisplay;
            pioSelectedPrice = optionPrice;
            if (parseFloat(optionPrice) > 0) {
              pioSelectedSubmitValue = optionLabelDisplay + " |" + pioCurrencyConverter(storeCurrency, optionPrice);
            } else {
              pioSelectedSubmitValue = optionLabelDisplay;
            }
          }
          
          var priceLabel = "";
          if (parseFloat(optionPrice) > 0) {
            var priceWithCurrency = pioCurrencyConverter(storeCurrency, optionPrice);
            priceLabel = " (+" + escapeHtmlText(priceWithCurrency) + ")";
          }
          
          var tooltipHtml = "";
          if (tooltipStyle == 1) {
            var tooltipText = (optionLabelDisplay + priceLabel + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
            tooltipHtml = '<span class="pio-swatch-tooltip">' + tooltipText + "</span>";
          }
          
          // Validate color format
          if (!optionColor.match(/^#[0-9A-Fa-f]{6}$/)) {
            optionColor = "#000000";
          }
          
          swatchHtml +=
            '<button type="button" ' +
            'class="pioColorSwatch ' + isRequiredClass + isSelected +
            '" data-value="' + optionLabelDisplaySafe +
            '" data-price="' + escapeHtmlText(optionPrice) +
            '" data-color="' + escapeHtmlText(optionColor) +
            '" data-index="' + i +
            '">' +
            tooltipHtml +
            '<span class="pio-color-swatch-box" style="background-color: ' + optionColor + '; width: ' + swatchColorWidth + 'px; height: ' + swatchColorHeight + 'px;"></span>' +
            '</button>';
        }
        
        var swatchContainerClass = "pio-swatch-container";
        if (swatchStyle == "2") {
          swatchContainerClass += " pio-swatch-vertical";
        } else {
          swatchContainerClass += " pio-swatch-horizontal";
        }
        
        // Build selected value div only if default value exists (option-wise price)
        var selectedValueDiv = "";
        if (defaultValue && defaultValue.trim() !== "") {
          var displayPartsColor = [];
          for (var dc = 0; dc < optionsArray.length; dc++) {
            if (defaultValue === optionsArray[dc]) {
              var optPrice = parseFloat(priceArray[dc]) || 0;
              var part = typeof pioGetTranslatedOptionLabel === "function"
                ? htmlToText(pioGetTranslatedOptionLabel(field, optionsArray[dc]))
                : htmlToText(optionsArray[dc]);
              if (optPrice > 0) {
                part += " (+" + pioCurrencyConverter(storeCurrency, optPrice) + ")";
              }
              displayPartsColor.push(part);
            }
          }
          var displayValue = escapeHtmlText(displayPartsColor.join(", "));
          selectedValueDiv = '<div class="pio-selected-value" id="' + pioFieldCartNameAttr + '_selected">' + displayValue + '</div>';
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '" ' +
          'data-multiple="' + (allowMultiple ? "1" : "0") + '" ' +
          'data-min="' + minSelection + '" ' +
          'data-max="' + maxSelection + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (parseInt(field.required) ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          selectedValueDiv +
          '<span class="td-content">' +
          '<div class="' + swatchContainerClass + '">' +
          swatchHtml +
          '</div>' +
          '<input class="pioColorSwatch__original" id="' +
          pioFieldCartNameAttr +
          '_original" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' + escapeHtmlText(pioSelectedPrice) + '" value="' + escapeHtmlText(pioSelectedSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadRadio = function (key, field) {
        console.log("Radio", field);
        var isRequiredClass = "";
        var radioHtml = "";
        var pioFieldLabel = htmlToText(pioloadLanguage(key, field, "label"));
        var pioFieldLabelHtml = escapeHtmlText(pioFieldLabel);
        var pioFieldCartName = htmlToText(field?.name || "");
        var pioFieldCartNameAttr = escapeHtmlText(pioFieldCartName);
        
        // Use new option_values array structure
        var optionsArray = [];
        var priceArray = [];
        
        if (field.option_values && Array.isArray(field.option_values) && field.option_values.length > 0) {
          for (var i = 0; i < field.option_values.length; i++) {
            optionsArray.push(field.option_values[i].label);
            priceArray.push(field.option_values[i].price || "");
          }
        }

        // Handle single default_value
        var defaultValue = field.default_value || "";
        
        if (field.required) {
          isRequiredClass = "required";
        }
        
        if (field.html_class == null) {
          field.html_class = "";
        }
        field.html_class = sanitizeClassName(field.html_class);
        
        if (field.column_width == null) {
          field.column_width = "100";
        }

        var pioFieldPrice = "";
        var pioSelectedFirst = "";
        var pioSelectedSubmitValue = "";
        for (var i = 0; i < optionsArray.length; i++) {
          var piooptionPrice = "";
          var piooptionPriceLabel = "";
          var optionLabel = optionsArray[i];
          var optionLabelDisplay = typeof pioGetTranslatedOptionLabel === "function" ? htmlToText(pioGetTranslatedOptionLabel(field, optionLabel)) : htmlToText(optionLabel);
          var optionLabelDisplaySafe = escapeHtmlText(optionLabelDisplay);
          var optionInputId = escapeHtmlText(optionLabel + "_" + pioFieldCartName);
          var isChecked = (defaultValue === optionLabel) ? " checked" : "";
          if (defaultValue === optionLabel) {
            pioSelectedFirst = optionLabelDisplay;
            pioFieldPrice = priceArray[i] || "";
            if (parseFloat(priceArray[i]) > 0) {
              pioSelectedSubmitValue = optionLabelDisplay + " |" + pioCurrencyConverter(storeCurrency, priceArray[i]);
            } else {
              pioSelectedSubmitValue = optionLabelDisplay;
            }
          }

          if (parseFloat(priceArray[i]) > 0) {
            piooptionPrice = priceArray[i];
            var priceLabel = pioCurrencyConverter(storeCurrency, piooptionPrice);
            piooptionPriceLabel = " (+" + escapeHtmlText(priceLabel) + ")";
          } else {
            piooptionPrice = "";
            piooptionPriceLabel = "";
          }
          
          radioHtml +=
            '<div class="pio-radio-option">' +
            '<label class="pioRadioLabel" for="' +
            optionInputId +
            '"><input ' +
            isRequiredClass +
            ' id="' +
            optionInputId +
            '" class="pioRadioButton ' +
            isRequiredClass +
            '" type="radio" name="' +
            pioFieldCartNameAttr +
            '" value="' +
            optionLabelDisplaySafe +
            '" pio-price="' +
            escapeHtmlText(piooptionPrice) +
            '"' + isChecked +
            '><span class="checkmark"></span>' +
            optionLabelDisplaySafe +
            piooptionPriceLabel +
            "</label>" +
            '</div>';
        }
        
        var helpText = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "help_text") || field.help_text || "")
          : htmlToText(field.help_text || "");
        var helpTextSafe = escapeHtmlText(helpText);
        var helpPos = field.help_text_position || "1";
        var helpTextHtml = generateHelpTextHtml(helpTextSafe, helpPos);
        var helpTextAfterLabel = (helpPos === "1" || helpPos === 1) ? helpTextHtml : "";
        var helpTextInLabel = (helpPos === "4" || helpPos === 4) ? helpTextHtml : "";
        var helpTextAtEnd = (helpPos === "2" || helpPos === 2) ? helpTextHtml : "";
        var helpTextAtStart = (helpPos === "3" || helpPos === 3) ? helpTextHtml : "";
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " " +
          (field.hidden_label == "1" ? "pio-label-hidden" : "") +
          " " +
          field.html_class +
          '" style="width:' + (field.column_width || "100") + '%;" ' +
          'data-help="' + helpTextSafe + '" ' +
          'data-help-pos="' + helpPos + '">' +
          helpTextAtStart +
          '<label class="td-label" for="' +
          pioFieldCartNameAttr +
          '">' +
          pioFieldLabelHtml +
          (field.required ? ' <span class="pio-required">*</span>' : '') +
          helpTextInLabel +
          '</label>' +
          helpTextAfterLabel +
          '<span class="td-content">' +
          radioHtml +
          "<input " +
          isRequiredClass +
          ' class="pioRadioButton__original' +
          '" id="' +
          pioFieldCartNameAttr +
          "_original" +
          '" type="hidden" name="properties[' +
          pioFieldCartNameAttr +
          ']" pio-price="' +
          escapeHtmlText(pioFieldPrice) +
          '" value="' + escapeHtmlText(pioSelectedSubmitValue) + '"></span>' +
          helpTextAtEnd +
          '</div>'
        );
      };
      loadHeading = function (key, field) {
        console.log("Heading", field);
        var content = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "content") || field.content || "")
          : htmlToText(field.content || "");
        var contentHtml = escapeHtmlText(content);
        var color = field.color || "#000000";
        var headingStyle = field.heading_style || "h1";
        var columnWidth = field.column_width || "100";
        var htmlClass = sanitizeClassName(field.html_class || "");
        
        // Validate heading_style to ensure it's a valid heading tag
        var validHeadings = ["h1", "h2", "h3", "h4", "h5", "h6"];
        if (validHeadings.indexOf(headingStyle.toLowerCase()) === -1) {
          headingStyle = "h1";
        }
        if (!String(color).match(/^#[0-9A-Fa-f]{6}$/)) {
          color = "#000000";
        }
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-heading " +
          htmlClass +
          '" style="width:' + columnWidth + '%;">' +
          "<" + headingStyle.toLowerCase() +
          ' class="pio-heading-text" style="color:' + color + '; margin: 0; padding: 0;">' +
          contentHtml +
          "</" + headingStyle.toLowerCase() + ">" +
          "</div>"
        );
      };
      loadDivider = function (key, field) {
        console.log("Divider", field);
        var color = field.color || "#000000";
        var borderStyle = field.border_style || "solid";
        var thickness = field.thickness || 1;
        var columnWidth = field.column_width || "100";
        var htmlClass = sanitizeClassName(field.html_class || "");
        var validBorderStyles = ["solid", "dashed", "dotted", "double"];
        if (validBorderStyles.indexOf(String(borderStyle).toLowerCase()) === -1) {
          borderStyle = "solid";
        }
        thickness = parseInt(thickness, 10);
        if (isNaN(thickness) || thickness < 1) {
          thickness = 1;
        }
        if (!String(color).match(/^#[0-9A-Fa-f]{6}$/)) {
          color = "#000000";
        }
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-divider " +
          htmlClass +
          '" style="width:' + columnWidth + '%;">' +
          '<hr class="pio-divider-line" style="border: none; border-top: ' + thickness + 'px ' + borderStyle + ' ' + color + '; margin: 0; padding: 0;">' +
          "</div>"
        );
      };
      loadSpacing = function (key, field) {
        console.log("Spacing", field);
        var spacingHeight = field.height || 0;
        var columnWidth = field.column_width || "100";
        var htmlClass = sanitizeClassName(field.html_class || "");
        spacingHeight = parseInt(spacingHeight, 10);
        if (isNaN(spacingHeight) || spacingHeight < 0) {
          spacingHeight = 0;
        }
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-spacing " +
          htmlClass +
          '" style="width:' + columnWidth + '%; height:' + spacingHeight + 'px; min-height:' + spacingHeight + 'px; display: block;"></div>'
        );
      };
      loadParagraph = function (key, field) {
        console.log("Paragraph", field);
        var content = typeof pioloadLanguage === "function"
          ? (pioloadLanguage(key, field, "content") || field.content || "")
          : (field.content || "");
        var columnWidth = field.column_width || "100";
        var htmlClass = sanitizeClassName(field.html_class || "");
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-paragraph " +
          htmlClass +
          '" style="width:' + columnWidth + '%;">' +
          '<p class="pio-paragraph-text">' +
          content +
          "</p>" +
          "</div>"
        );
      };
      loadHtmlCode = function (key, field) {
        console.log("HTML Code", field);
        var htmlCode = typeof pioloadLanguage === "function"
          ? (pioloadLanguage(key, field, "html_code") || field.html_code || "")
          : (field.html_code || "");
        var htmlClass = sanitizeClassName(field.html_class || "");
        var fieldName = escapeHtmlText(htmlToText(field.name || ""));
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-html-code " +
          htmlClass +
          '" data-name="' + fieldName + '">' +
          htmlCode +
          "</div>"
        );
      };
      loadPopup = function (key, field) {
        console.log("Popup", field);
        var modalTitle = typeof pioloadLanguage === "function"
          ? htmlToText(pioloadLanguage(key, field, "modal_title") || field.modal_title || "")
          : htmlToText(field.modal_title || "");
        var modalTitleHtml = escapeHtmlText(modalTitle);
        var modalContent = typeof pioloadLanguage === "function"
          ? (pioloadLanguage(key, field, "modal_content") || field.modal_content || "")
          : (field.modal_content || "");
        var columnWidth = field.column_width || "100";
        var htmlClass = sanitizeClassName(field.html_class || "");
        var modalId = "pio-modal-" + String(key).replace(/[^\w\-]/g, "");
        
        return (
          '<div class="td-line-item-field field-' +
          key +
          " pio-popup " +
          htmlClass +
          '" style="width:100%;">' +
          '<button type="button" class="pio-popup-trigger" data-modal-id="' + modalId + '">' +
          escapeHtmlText(modalTitle || "Open") +
          "</button>" +
          '<div class="pio-modal-overlay" id="' + modalId + '">' +
          '<div class="pio-modal-content" style="width: ' + columnWidth + '%;">' +
          '<div class="pio-modal-header">' +
          '<h3 class="pio-modal-title">' + modalTitleHtml + "</h3>" +
          '<button type="button" class="pio-modal-close" aria-label="Close">&times;</button>' +
          "</div>" +
          '<div class="pio-modal-body">' +
          modalContent +
          "</div>" +
          "</div>" +
          "</div>" +
          "</div>"
        );
      };
      pioGetProduct = function (handle) {

        if (pioProductData != "") {
          return pioProductData;
        } else {
          $pioobject.ajax({
            dataType: "json",
            cache: false,
            async: false,
            url: "/products/" + handle + ".json",
            success: function (data) {
              pioProductData = data.product;
            },
            error: function (error) {
              //throw 'Pio product lookup error';
            },
          });
          return pioProductData;
        }
      };
      pioValidateRule = function (optionSet) {
        var pioProductHandle = $pioobject(".pio-multiple-options").data("phandle");

        // When isOldUserFlag is true and planTierValue is 3, use product_condition (first item)
        // condition_option: 1=Product tag, 2=Product vendor, 3=Product type, 4=Product url, 5=Product handle, 6=All products
        if (isOldUserFlag == true) {
          var cond = optionSet.product_condition && optionSet.product_condition[0];
          if (!cond) return false;
          var condOption = String(cond.condition_option);
          var condValue = cond.value != null ? cond.value : "";
          if (condOption == "6") return true; // All products – option set visible on all products
          var product = null;
          var pioProductEl = document.querySelector("[pio-product-data-json]");
          if (pioProductEl && pioProductEl.innerHTML) {
            try { product = JSON.parse(pioProductEl.innerHTML); } catch (e) {}
          }
          if (!product && pioProductData && pioProductData != "") product = pioProductData;
          if (!product && pioProductHandle) product = pioGetProduct(pioProductHandle);
          if (!product || product == "") return false;
          if (condOption == "1") {
            var tags = product.tags || [];
            if (Array.isArray(tags)) return tags.indexOf(condValue) != -1;
            if (typeof tags == "string") return tags.split(",").map(function (t) { return (t || "").trim(); }).indexOf(condValue) != -1;
            return false;
          }
          if (condOption == "2") return (product.vendor || "") == condValue;
          if (condOption == "3") return (product.type || product.product_type || "") == condValue;
          if (condOption == "4") {
            var currentUrl = (typeof location != "undefined" && location.href) ? location.href : "";
            return currentUrl == condValue || (product.url && product.url == condValue);
          }
          if (condOption == "5") return (product.handle || "") == condValue;
          return false;
        }

        // When isOldUserFlag is false
        if (isOldUserFlag == false) {
          if (optionSet?.product_type == 1) {
            return true;
          } else if (optionSet?.product_type == 2) {
            var productData = optionSet.product_data || [];
            if (productData.length === 0) return false;
            var product = null;
            var pioProductEl = document.querySelector("[pio-product-data-json]");
            if (pioProductEl && pioProductEl.innerHTML) {
              try { product = JSON.parse(pioProductEl.innerHTML); } catch (e) {}
            }
            if (!product && pioProductData && pioProductData != "") product = pioProductData;
            if (!product && pioProductHandle) product = pioGetProduct(pioProductHandle);
            if (!product || product == "") return false;
            var currentHandle = (product.handle || "").toString();
            var currentId = (product.id != null ? product.id : "").toString();
            for (var pd = 0; pd < productData.length; pd++) {
              var item = productData[pd];
              var itemHandle = (item.handle || "").toString();
              var itemId = (item.id || "").toString();
              if (currentHandle && itemHandle && currentHandle === itemHandle) return true;
              if (currentId && itemId && (currentId === itemId || itemId.indexOf(currentId) !== -1)) return true;
            }
            return false;
          } else if (optionSet?.product_type == 3) {
            var conditions = optionSet.product_condition || [];
            if (conditions.length == 0) return false;
            var conditionType = optionSet.condition_type == 2 ? "AND" : "OR"; // 1 = OR, 2 = AND
            var product = null;
            var pioProductEl = document.querySelector("[pio-product-data-json]");
            if (pioProductEl && pioProductEl.innerHTML) {
              try { product = JSON.parse(pioProductEl.innerHTML); } catch (e) {}
            }
            if (!product && pioProductData && pioProductData != "") product = pioProductData;
            if (!product && pioProductHandle) product = pioGetProduct(pioProductHandle);
            if (!product || product == "") return false;
            var currentUrl = (typeof location != "undefined" && location.href) ? location.href : "";
            var results = [];
            for (var c = 0; c < conditions.length; c++) {
              var cond = conditions[c];
              var condOption = String(cond.condition_option);
              var condValue = cond.value != null ? cond.value : "";
              var operator = cond.operator; // 1 = contains, 2 = not contains
              if (condOption == "6") {
                results.push(true);
                continue;
              }
              var match = false;
              if (condOption == "1") {
                var tags = product.tags || [];
                if (Array.isArray(tags)) match = tags.indexOf(condValue) != -1;
                else if (typeof tags == "string") match = tags.split(",").map(function (t) { return (t || "").trim(); }).indexOf(condValue) != -1;
              } else if (condOption == "2") {
                var vendorStr = (product.vendor || "").toString();
                match = vendorStr.indexOf(condValue) !== -1;
              } else if (condOption == "3") {
                var typeStr = (product.type || product.product_type || "").toString();
                match = typeStr.indexOf(condValue) !== -1;
              } else if (condOption == "4") {
                match = currentUrl.indexOf(condValue) !== -1 || (product.url && product.url.indexOf(condValue) !== -1);
              } else if (condOption == "5") {
                var handleStr = (product.handle || "").toString();
                match = handleStr.indexOf(condValue) !== -1;
              }
              if (operator == 2) match = !match; // 2 = not contains
              results.push(match);
            }
            if (conditionType == "OR") {
              for (var r = 0; r < results.length; r++) { if (results[r]) return true; }
              return false;
            }
            for (var r = 0; r < results.length; r++) { if (!results[r]) return false; }
            return true;
          }
        }

        if(pioProductHandle) {
          switch (optionSet.option_type) {
            case 1:
              // Tags
              
              var tag = optionSet.option_name;
              var getProduct = pioGetProduct(pioProductHandle);
              var productTags = "";
              if (getProduct != "") {
                productTags = getProduct.tags;
              }
              // var productTagsArray = productTags.split(',');
              var productTagsArray = $pioobject.map(
                productTags.split(","),
                $pioobject.trim
              );
              if (
                productTags != "" &&
                $pioobject.inArray(tag, productTagsArray) != -1
              ) {
                return true;
              } else {
                return false;
              }
              break;
            case 2:
              // Vendor
              var vendor = optionSet.option_name;
              var getProduct = pioGetProduct(pioProductHandle);
              if (getProduct != "" && getProduct.vendor == vendor) {
                return true;
              } else {
                return false;
              }
              break;
            case 3:
              // Type
              var productType = optionSet.option_name;
              var getProduct = pioGetProduct(pioProductHandle);
              if (getProduct != "" && getProduct.product_type == productType) {
                return true;
              } else {
                return false;
              }
              break;
            case 4:
              // URL
              var productURL = optionSet.option_name;
              var currentURL = $pioobject(location).attr("href");
              if (currentURL == productURL) {
                return true;
              } else {
                return false;
              }
              break;
            case 5:
              // Handle
  
              //var getProduct = pioGetProduct(pioProductHandle);
              var productHandle = optionSet.option_name;
              if (getProduct != "" && productHandle == pioProductHandle) {
                return true;
              } else {
                return false;
              }
  
              break;
            default:
              // All Products
              return true;
          }
        } else {
          return false;
        }
      };
      
      var getTranslationFromSetting = function (translationData, lang, optionSetId, optionId, originalText) {
        if (!translationData || !lang || originalText == null) return null;
        var langData = translationData[lang];
        if (!langData || !langData.labels) return null;
        var labels = langData.labels;
        for (var sectionKey in labels) {
          if (!Object.prototype.hasOwnProperty.call(labels, sectionKey)) continue;
          var arr = labels[sectionKey];
          if (!Array.isArray(arr)) continue;
          for (var idx = 0; idx < arr.length; idx++) {
            var item = arr[idx];
            if (
              String(item.option_set_id) === String(optionSetId) &&
              String(item.option_id) === String(optionId) &&
              item.label === originalText
            ) {
              return item.translated_text;
            }
          }
        }
        return null;
      };
      pioloadLanguage = function (piokey, field, pioNeededParam) {
        var pioLanguage = $pioobject("html").attr("lang");
        if (!pioLanguage || pioLanguage == "") {
          pioLanguage = $pioobject("#pioLang").attr("lang");
        }
        var pioLanguageText = {};
        var optionSetId = field.option_set_id != null ? field.option_set_id : field.optionset_id;
        var optionId = field.option_id;
        var translationData = pioLanguageSettings.translation_data_setting;
        if (translationData && pioLanguage && optionSetId != null && optionId != null) {
          var originalValue = pioNeededParam === "label" ? field.label : (pioNeededParam === "placeholder" ? field.placeholder : (pioNeededParam === "name" ? field.name : (pioNeededParam === "help_text" ? field.help_text : (pioNeededParam === "content" ? field.content : (pioNeededParam === "html_code" ? field.html_code : (pioNeededParam === "modal_title" ? field.modal_title : (pioNeededParam === "modal_content" ? field.modal_content : field[pioNeededParam])))))));
          if (originalValue != null) {
            var translated = getTranslationFromSetting(translationData, pioLanguage, optionSetId, optionId, originalValue);
            if (translated != null) {
              return translated;
            }
          }
        }
        if (
          !pioLanguageSettings.language ||
          pioLanguageSettings.language.length === 0
        ) {
          //when there is no language created
          pioLanguageText["label"] = field.label;
          pioLanguageText["name"] = field.name;
          pioLanguageText["placeholder"] = field.placeholder;
          if (pioNeededParam == "input_options") {
            pioLanguageText["input_options"] = field.input_options ? field.input_options.split(",") : [];
          }
        } else {
          var pioshopLanguage = pioLanguageSettings.language;
          
          $pioobject.each(pioshopLanguage, function (index, piolang) {
            if (index == pioLanguage) {
              $pioobject.each(piolang, function (piokey, langfields) {
                $pioobject.each(langfields, function (piokey, langfield) {
                  if (
                    langfield.optionset_id == field.optionset_id &&
                    langfield.option_id == field.option_id &&
                    langfield.label == pioNeededParam
                  ) {
                    pioLanguageText[pioNeededParam] = langfield.data;
                    return false;
                  }
                });
              });
              return false;
            } else {
              pioLanguageText["label"] = field.label;
              pioLanguageText["name"] = field.name;
              pioLanguageText["placeholder"] = field.placeholder;
              if (pioNeededParam == "input_options") {
                pioLanguageText["input_options"] = field.input_options ? field.input_options.split(",") : [];
              }
            }
          });
        }
        return pioLanguageText[pioNeededParam];
      };
      /** Get translated label for an option value (e.g. select/radio/checkbox option) from translation_data_setting */
      pioGetTranslatedOptionLabel = function (field, originalLabel) {
        if (originalLabel == null) return originalLabel;
        var pioLanguage = $pioobject("html").attr("lang");
        if (!pioLanguage || pioLanguage == "") {
          pioLanguage = $pioobject("#pioLang").attr("lang");
        }
        var translationData = pioLanguageSettings.translation_data_setting;
        var optionSetId = field.option_set_id != null ? field.option_set_id : field.optionset_id;
        var optionId = field.option_id;
        if (!translationData || !pioLanguage || optionSetId == null || optionId == null) return originalLabel;
        var translated = getTranslationFromSetting(translationData, pioLanguage, optionSetId, optionId, originalLabel);
        return translated != null ? translated : originalLabel;
      };

      //For text field price
      $pioobject(document).on("input", ".pioShortText", function () {
        var $input = $pioobject(this);
        var value = $input.val();

        // ALLOWED VALUES
        var allowed = $input.data("allowed");
        if (allowed === "2") {
          // Only letters
          value = value.replace(/[^a-zA-Z]/g, "");
        } else if (allowed === "3") {
          // Letters & numbers
          value = value.replace(/[^a-zA-Z0-9]/g, "");
        }

        // TEXT TRANSFORM
        var transform = $input.data("transform");
        if (transform === "2") {
          value = value.toUpperCase();
        } else if (transform === "3") {
          value = value.toLowerCase();
        }

        // MAXLENGTH
        var max = parseInt($input.attr("maxlength"), 10);
        if (max && value.length > max) {
          value = value.substring(0, max);
        }
        $input.val(value);

        // PRICE SYNC
        // Find hidden input from field container (not .next()) so char counter
        // inserted between visible + hidden inputs does not break sync.
        var $shortOriginal = $input
          .closest(".td-content")
          .find(".pioShortText__original")
          .first();
        if (value != "") {
          var pioTxtPrice = $input.attr("pio-price");
          if (pioTxtPrice) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioTxtPrice
            );
            $shortOriginal.val(value + " |" + priceWithCurrency);
          } else {
            $shortOriginal.val(value);
          }
        } else {
          $shortOriginal.val(" ");
        }

        // CHAR. COUNTER
        if (max && $input.data("show-counter") != "0") {
          var $counter = $input
            .closest(".td-content")
            .find(".pio-char-counter");

          if (!$counter.length) {
            $counter = $pioobject(
              '<span class="pio-char-counter">0 / ' + max + "</span>"
            );
            $input.after($counter);
          }
          $counter.toggleClass("is-max", value.length === max);
          $counter.text(value.length + " / " + max);
        }

        // VALIDATION
        var error = "";
        if ($input.attr("required") && !value?.trim()) {
          error = "This field is required";
        }
        pioRenderError($input.closest(".td-line-item-field"), error); 
      });

      //For email field price
      $pioobject(document).on("input", ".pioEmail", function () {
        var $input = $pioobject(this);
        var value = $input.val();

        // PRICE SYNC
        if (value != "") {
          var pioEmailPrice = $input.attr("pio-price");
          if (pioEmailPrice) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioEmailPrice
            );
            $input
              .next(".pioEmail__original")
              .val(value + " |" + priceWithCurrency);
          } else {
            $input
              .next(".pioEmail__original")
              .val(value);
          }
        } else {
          $input.next(".pioEmail__original").val(" ");
        }

        // VALIDATION
        var error = "";
        var required = $input.attr("required");
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (required && (!value || value.trim() === "")) {
          error = "This field is required";
        } else if (value && value.trim() !== "" && !emailRegex.test(value.trim())) {
          error = "Please enter a valid email address";
        }
        
        pioRenderError($input.closest(".td-line-item-field"), error);
      });

      //For color picker field price
      $pioobject(document).on("input change", ".pioColorPicker", function () {
        var $input = $pioobject(this);
        var $field = $input.closest(".td-line-item-field");
        var value = $input.val();

        // PRICE SYNC
        if (value != "") {
          var pioColorPrice = $input.attr("pio-price");
          if (pioColorPrice) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioColorPrice
            );
            $input
              .next(".pioColorPicker__original")
              .val(value + " |" + priceWithCurrency);
          } else {
            $input
              .next(".pioColorPicker__original")
              .val(value);
          }
        } else {
          $input.next(".pioColorPicker__original").val(" ");
        }

        // VALIDATION
        var error = "";
        var required = $input.attr("required");
        
        if (required && (!value || value.trim() === "")) {
          error = "This field is required";
        }
        
        pioRenderError($field, error);
      });
  
      //For text area field price
      $pioobject(document).on("input", ".pioLongText", function () {
        var $input = $pioobject(this);
        var value = $input.val();

        // ALLOWED VALUES
        var allowed = $input.data("allowed");
        if (allowed === "2") {
          value = value.replace(/[^a-zA-Z\s]/g, "");
        } else if (allowed === "3") {
          value = value.replace(/[^a-zA-Z0-9\s]/g, "");
        }

        // TEXT TRANSFORM
        var transform = $input.data("transform");
        if (transform === "2") {
          value = value.toUpperCase();
        } else if (transform === "3") {
          value = value.toLowerCase();
        }

        // MAXLENGTH
        var max = parseInt($input.attr("maxlength"), 10);
        if (max && value.length > max) {
          value = value.substring(0, max);
        }
        $input.val(value);

        // PRICE SYNC
        // Find hidden input from field container (not .next()) so char counter
        // inserted between visible + hidden inputs does not break sync.
        var $longOriginal = $input
          .closest(".td-content")
          .find(".pioLongText__original")
          .first();
        if (value != "") {
          var pioLongTxtPrice = $input.attr("pio-price");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            pioLongTxtPrice
          );
          if (pioLongTxtPrice != "" && pioLongTxtPrice != null) {
            $longOriginal.val(value + " |" + priceWithCurrency);
          } else {
            $longOriginal.val(value);
          }
        } else {
          $longOriginal.val(" ");
        }

        // CHAR. COUNTER
        if (max && $input.data("show-counter") != "0") {
          var $counter = $input
            .closest(".td-content")
            .find(".pio-char-counter");

          if (!$counter.length) {
            $counter = $pioobject(
              '<span class="pio-char-counter">0 / ' + max + "</span>"
            );
            $input.after($counter);
          }
          $counter.toggleClass("is-max", value.length === max);
          $counter.text(value.length + " / " + max);
        }

        // VALIDATION
        var error = "";
        if ($input.attr("required") && !value?.trim()) {
          error = "This field is required";
        }
        pioRenderError($input.closest(".td-line-item-field"), error); 
      });

      //For switch field
      $pioobject(document).on("change", ".pioSwitch", function () {
        var $switch = $pioobject(this);
        
        var isChecked = $switch.is(":checked");
        var switchValue = isChecked ? "Yes" : "";
        var pioSwitchPrice = $switch.attr("pio-price");
        
        if (isChecked) {
          if (pioSwitchPrice != "" && pioSwitchPrice != null) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioSwitchPrice
            );
            $switch
              .closest(".pio-switch-wrapper")
              .find(".pioSwitch__original")
              .val(switchValue + " |" + priceWithCurrency);
          } else {
            $switch
              .closest(".pio-switch-wrapper")
              .find(".pioSwitch__original")
              .val(switchValue);
          }
        } else {
          $switch
            .closest(".pio-switch-wrapper")
            .find(".pioSwitch__original")
            .val(" ");
        }
      });

      //For number field price
      $pioobject(document).on("input", ".pioNumber", function () {
        var $input = $pioobject(this);
        var value = $input.val();

        // PRICE SYNC
        if (value != "") {
          var pioNumPrice = $input.attr("pio-price");
          if (pioNumPrice) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioNumPrice
            );
            $input
              .next(".pioNumber__original")
              .val(value + " |" + priceWithCurrency);
          } else {
            $input
              .next(".pioNumber__original")
              .val(value);
          }
        } else {
          $input.next(".pioNumber__original").val(" ");
        }

        // VALIDATION
        var error = "";
        var min = parseFloat($input.attr("min"));
        var max = parseFloat($input.attr("max"));
        var numValue = parseFloat(value);
        var required = $input.attr("required");

        if (required && (!value || value.trim() === "")) {
          error = "This field is required";
        } else if (value && !isNaN(numValue)) {
          if (!isNaN(min) && numValue < min) {
            error = "Minimum value is " + min;
          } else if (!isNaN(max) && numValue > max) {
            error = "Maximum value is " + max;
          }
        } else if (value && isNaN(numValue)) {
          error = "Please enter a valid number";
        }
        
        pioRenderError($input.closest(".td-line-item-field"), error);
      });
  
      //For Date field price
      $pioobject(document).on("change", ".pioDatePick", function () {
        var $dateInput = $pioobject(this);
        var $field = $dateInput.closest(".td-line-item-field");
        
        var isRange = $dateInput.hasClass("pioDatePick-start") || $dateInput.hasClass("pioDatePick-end");
        var $hidden = $field.find(".pioDatePick__original");
        var dateFormatId = $field.find(".pioDatePick").attr("data-format") || "1";
        
        if (isRange) {
          // Range mode handling
          var $startInput = $field.find(".pioDatePick-start");
          var $endInput = $field.find(".pioDatePick-end");
          var startValue = ($startInput.val() || "").trim();
          var endValue = ($endInput.val() || "").trim();
          
          // Set min/max so end cannot be before start, start cannot be after end
          if (startValue) {
            $endInput.attr("min", startValue);
            if (endValue && endValue < startValue) {
              $endInput.val("");
              endValue = "";
            }
          } else {
            $endInput.removeAttr("min");
          }
          if (endValue) {
            $startInput.attr("max", endValue);
            if (startValue && startValue > endValue) {
              $startInput.val("");
              startValue = "";
            }
          } else {
            $startInput.removeAttr("max");
          }
          
          var combinedValue = "";
          if (startValue && endValue) {
            combinedValue = pioFormatDateValue(startValue, dateFormatId) + " to " + pioFormatDateValue(endValue, dateFormatId);
          } else if (startValue) {
            combinedValue = pioFormatDateValue(startValue, dateFormatId);
          } else if (endValue) {
            combinedValue = pioFormatDateValue(endValue, dateFormatId);
          }
          
          if (combinedValue != "") {
            var pioDatePrice = $dateInput.attr("pio-price");
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioDatePrice
            );
            if (pioDatePrice != "" && pioDatePrice != null) {
              $hidden.val(combinedValue + " |" + priceWithCurrency);
            } else {
              $hidden.val(combinedValue);
            }
          } else {
            $hidden.val(" ");
          }
          
          // VALIDATION for range
          var error = "";
          var isRequired = $dateInput.attr("required");
          if (isRequired && (!startValue || !endValue)) {
            error = "This field is required";
          }
          pioRenderError($field, error);
          pioUpdateDateDisplay($startInput);
          pioUpdateDateDisplay($endInput);
        } else {
          // Single mode handling: format value according to date_format
          var rawVal = ($dateInput.val() || "").trim();
          var displayVal = rawVal ? pioFormatDateValue(rawVal, dateFormatId) : "";
          if (displayVal != "") {
            var pioDatePrice = $dateInput.attr("pio-price");
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              pioDatePrice
            );
            if (pioDatePrice != "" && pioDatePrice != null) {
              $hidden.val(displayVal + " |" + priceWithCurrency);
            } else {
              $hidden.val(displayVal);
            }
          } else {
            $hidden.val(" ");
          }
          
          // VALIDATION for single
          var error = "";
          var isRequired = $dateInput.attr("required");
          if (isRequired && !rawVal) {
            error = "This field is required";
          }
          pioRenderError($field, error);
          pioUpdateDateDisplay($dateInput);
        }
      });
  
      //For Image field price
      $pioobject(document).on("change", ".pioImage", function () {
        var $fileInput = $pioobject(this);
        var $field = $fileInput.closest(".td-line-item-field");
        var $hidden = $fileInput.closest(".pio-file-wrapper").find(".pioImage__original").first();
        
        var files = $fileInput[0].files;
        var isMultiple = $fileInput.attr("multiple") !== undefined;
        var allowedExtensions = [];
        var maxFiles = $fileInput.data("max-files") || 10;
        
        // Get allowed extensions from data attribute
        var extensionsData = $field.data("allowed-extensions");
        if (extensionsData) {
          try {
            allowedExtensions = typeof extensionsData === 'string' ? JSON.parse(extensionsData) : extensionsData;
          } catch(e) {
            // If parsing fails, try as string array
            allowedExtensions = Array.isArray(extensionsData) ? extensionsData : [];
          }
        }
        
        // VALIDATION - Check file extensions
        var error = "";
        var isValid = true;
        
        if (files.length > maxFiles) {
          isValid = false;
          error = "Maximum " + maxFiles + " file(s) allowed. Please upload fewer files.";
          pioRenderError($field, error);
          return;
        }

        if (isValid && files.length > 0 && allowedExtensions.length > 0) {
          for (var i = 0; i < files.length; i++) {
            var fileName = files[i].name;
            var fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
            
            // Check if extension is in allowed list (with or without dot)
            var extensionFound = false;
            for (var j = 0; j < allowedExtensions.length; j++) {
              var allowedExt = allowedExtensions[j].toLowerCase();
              // Normalize extension format (ensure it starts with dot)
              if (!allowedExt.startsWith('.')) {
                allowedExt = '.' + allowedExt;
              }
              if (fileExtension === allowedExt) {
                extensionFound = true;
                break;
              }
            }
            
            if (!extensionFound) {
              isValid = false;
              error = "Invalid file type. Allowed extensions: " + allowedExtensions.join(", ");
              break;
            }
          }
        }

        // VALIDATION - Check total upload size (all selected files combined)
        var maxTotalBytes = 10 * 1024 * 1024; // 10 MB
        var totalBytes = 0;
        for (var i = 0; i < files.length; i++) {
          totalBytes += files[i].size || 0;
        }
        if (totalBytes > maxTotalBytes) {
          isValid = false;
          error = "Maximum total upload size is 10 MB. Please upload fewer files or smaller files.";
          pioRenderError($field, error);
          return;
        }
        
        // VALIDATION - Check required
        var isRequired = $fileInput.attr("required");
        if (isRequired && files.length === 0) {
          error = "This field is required";
          isValid = false;
        }
        
        // If validation fails, clear files and show error
        if (!isValid) {
          $fileInput.val("");
          pioRenderError($field, error);
          // Clear per-file inputs container (if present)
          var $multiFileInputs = $field.find(".pio-file-inputs").first();
          if ($multiFileInputs.length) {
            $multiFileInputs.empty();
          }
          $hidden.val(" ");
          return;
        }
        
        // Clear any previous errors
        pioRenderError($field, "");

        // Multi-upload: create per-file inputs so Shopify receives the actual binaries.
        // We still submit the combined filename list + price via the hidden .pioImage__original input.
        var $multiFileInputs = $field.find(".pio-file-inputs").first();
        if ($multiFileInputs.length) {
          $multiFileInputs.empty();
        }
        if (
          $multiFileInputs &&
          $multiFileInputs.length &&
          files &&
          files.length > 0 &&
          typeof DataTransfer !== "undefined"
        ) {
          var baseKey = $fileInput.attr("id");
          for (var i = 0; i < files.length; i++) {
            var dtSingle = new DataTransfer();
            dtSingle.items.add(files[i]);

            var perFileInput = document.createElement("input");
            perFileInput.type = "file";
            perFileInput.style.display = "none";
            perFileInput.name = "properties[" + baseKey + "-" + i + "]";
            perFileInput.files = dtSingle.files;

            $multiFileInputs.append(perFileInput);
          }
        }
        
        // PRICE SYNC
        if (files.length > 0) {
          var fileNames = [];
          for (var i = 0; i < files.length; i++) {
            fileNames.push(files[i].name);
          }
          // We intentionally do NOT store/display raw filenames in the cart/draft-order
          // properties. Keep a generic label instead.
          var filesValue = isMultiple ? "Upload file(s)" : "Upload file";
          
          var pioImagePrice = $fileInput.attr("pio-price");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            pioImagePrice
          );
          if (pioImagePrice != "" && pioImagePrice != null) {
            $hidden
              .val(filesValue + " |" + priceWithCurrency);
          } else {
            $hidden.val(filesValue);
          }
        } else {
          $hidden.val(" ");
        }

        if (typeof pioUpdateTotalPriceMessage === "function") {
          pioUpdateTotalPriceMessage();
        }
      });

      // Hook into your existing image change handler (add this near it)
      $pioobject(document).on("change", ".pioImage", function () {
        var $input = $pioobject(this);
        var $wrapper = $input.closest(".pio-file-wrapper");
        var files = $input[0].files;
        var isMultiple = $input.attr("multiple") !== undefined;

        // Only add listWrapper if files exist
        if (!files || !files.length) {
          // Remove listWrapper if it exists and no files
          $wrapper.find(".pio-file-list").remove();
          return;
        }

        // Check if listWrapper already exists, if not create it
        var $list = $wrapper.find(".pio-file-list");
        if (!$list.length) {
          var $listWrapper = '<div class="pio-file-list"></div>';
          $wrapper.append($listWrapper);
          $list = $wrapper.find(".pio-file-list");
        }

        $list.empty();
        $list.toggleClass("single", !isMultiple);

        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var url = "";
          var fileTypeLabel = "";
          if (file.type && file.type.startsWith("image/")) {
            url = URL.createObjectURL(file);
          } else {
            // For non-image files, show extension or mime subtype in the thumbnail area
            // (prevents empty preview boxes for e.g. .txt, .pdf, .mkv).
            var ext = "";
            if (file.name && file.name.lastIndexOf(".") !== -1) {
              ext = file.name.slice(file.name.lastIndexOf(".") + 1);
            }
            if (ext) {
              fileTypeLabel = ext.toUpperCase();
            } else if (file.type && file.type.indexOf("/") !== -1) {
              fileTypeLabel = (file.type.split("/")[1] || "").toUpperCase();
            } else {
              fileTypeLabel = "FILE";
            }
          }
          var card = [
            '<div class="pio-file-card" data-idx="' + i + '">',
            url
              ? '<img class="pio-file-thumb" src="' + url + '" alt="' + file.name + '"/>'
              : '<div class="pio-file-thumb" style="display:flex;align-items:center;justify-content:center;font-weight:600;">' + fileTypeLabel + "</div>",
            '<div class="pio-file-name">' + file.name + "</div>",
            '<button type="button" class="pio-file-remove" aria-label="Remove" data-remove="' + i + '">✕</button>',
            "</div>"
          ].join("");
          $list.append(card);
        }
      });

      // Remove file from selection (rebuild FileList via DataTransfer)
      $pioobject(document).on("click", ".pio-file-remove", function () {
        var $btn = $pioobject(this);
        var idx = parseInt($btn.data("remove"), 10);
        var $wrapper = $btn.closest(".pio-file-wrapper");
        var $input = $wrapper.find(".pioImage");
        var dt = new DataTransfer();
        var files = $input[0].files;
        for (var i = 0; i < files.length; i++) {
          if (i !== idx) dt.items.add(files[i]);
        }
        $input[0].files = dt.files;
        $input.trigger("change"); // re-render list and keep your price/validation flow
      });

      // For phone field (country + number)
      $pioobject(document).on("input", ".pioPhone, .pioPhoneCountry", function () {
        var $el = $pioobject(this);
        var $field = $el.closest(".td-line-item-field");

        // HELP TEXT

        var $wrap = $field.find(".pio-phone-wrapper");
        var country = ($wrap.find(".pioPhoneCountry").val() || "").toString().replace(/[^\d]/g, "");
        var phone = ($wrap.find(".pioPhone").val() || "").toString().trim();

        // Normalize phone to digits + common symbols only
        var phoneNormalized = phone.replace(/[^\d\s()+-]/g, "");

        var $hidden = $field.find(".pioPhone__original");
        var price = $field.find(".pioPhone").attr("pio-price");

        // VALIDATION
        var error = "";
        var required = $field.find(".pioPhone").attr("required");

        if (required && (!country || !phoneNormalized)) {
          error = "This field is required";
        } else if (phoneNormalized) {
          // basic sanity: at least 6 digits total in number part
          var digits = phoneNormalized.replace(/[^\d]/g, "");
          if (digits.length < 6) error = "Please enter a valid phone number";
        }

        pioRenderError($field, error);

        // PRICE SYNC
        if (country && phoneNormalized && !error) {
          var combined = "+" + country + " " + phoneNormalized;

          if (price != "" && price != null) {
            var priceWithCurrency = pioCurrencyConverter(storeCurrency, price);
            $hidden.val(combined + " |" + priceWithCurrency);
          } else {
            $hidden.val(combined);
          }
        } else {
          $hidden.val(" ");
        }
      });
  
      //For select field price
      $pioobject(document).on("change", ".pioSelect", function () {
        var $select = $pioobject(this);
        var values = [];
        var totalPrice = 0;

        // PRICE SYNC
        $select.find("option:selected").each(function () {
          var $opt = $pioobject(this);
          var label = $opt.val();
          var price = parseFloat($opt.data("price")) || 0;

          if (label) {
            values.push(label);
            totalPrice += price;
          }
        });
        var $hidden = $select.siblings(".pioSelect__original");
        if (values.length) {
          $hidden.attr("pio-price", totalPrice > 0 ? totalPrice : "");
          if (totalPrice > 0) {
            var priceWithCurrency = pioCurrencyConverter(
              storeCurrency,
              totalPrice
            );
            $hidden.val(values.join(", ") + " |" + priceWithCurrency);
          } else {
            $hidden.val(values.join(", "));
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION
        var error = "";
        if ($select.attr("required") && !values.length) {
          error = "This field is required";
        }

        pioRenderError($select.closest(".td-line-item-field"), error);
        return true;
      });

      //For button field
      $pioobject(document).on("click", ".pioButton", function () {
        var $button = $pioobject(this);
        var $field = $button.closest(".td-line-item-field");
        var $buttonGroup = $button.closest(".pio-button-group");
        var allowMultiple = $field.data("multiple") == "1";
        
        // Toggle selection
        if (allowMultiple) {
          // Multiple selection mode (like checkbox)
          $button.toggleClass("pio-button-selected");
        } else {
          // Single selection mode (like radio)
          $buttonGroup.find(".pioButton").removeClass("pio-button-selected");
          $button.addClass("pio-button-selected");
        }
        
        // Get selected values and prices
        var selectedButtons = $buttonGroup.find(".pioButton.pio-button-selected");
        var selectedValues = [];
        var selectedLabels = [];
        var totalPrice = 0;
        
        selectedButtons.each(function() {
          var value = $pioobject(this).data("value");
          var label = $pioobject(this).data("label");
          var price = parseFloat($pioobject(this).data("price")) || 0;
          selectedValues.push(value);
          if (label) {
            selectedLabels.push(label);
          }
          totalPrice += price;
        });
        
        var $hidden = $buttonGroup.find(".pioButton__original");
        var selectedValue = selectedLabels.join(", ");
        
        if (selectedValue != "") {
          $hidden.attr("pio-price", totalPrice > 0 ? totalPrice : "");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            totalPrice
          );
          if (totalPrice > 0) {
            $hidden.val(selectedValue + " |" + priceWithCurrency);
          } else {
            $hidden.val(selectedValue);
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION
        var error = "";
        var isRequired = $button.hasClass("required");
        if (isRequired && selectedValues.length === 0) {
          error = "This field is required";
        }
        pioRenderError($field, error);
      });

      //For image swatch field
      $pioobject(document).on("click", ".pioImageSwatch", function () {
        var $swatch = $pioobject(this);
        var $field = $swatch.closest(".td-line-item-field");
        var $swatchContainer = $swatch.closest(".pio-swatch-container");
        var allowMultiple = $field.data("multiple") == "1";
        var minSelection = parseInt($field.data("min")) || 0;
        var maxSelection = parseInt($field.data("max")) || 999;
        
        // Toggle selection
        if (allowMultiple) {
          // Multiple selection mode
          var selectedCount = $swatchContainer.find(".pioImageSwatch.pio-swatch-selected").length;
          
          if ($swatch.hasClass("pio-swatch-selected")) {
            // Deselect if above minimum
            if (selectedCount > minSelection) {
              $swatch.removeClass("pio-swatch-selected");
            }
          } else {
            // Select if below maximum
            if (selectedCount < maxSelection) {
              $swatch.addClass("pio-swatch-selected");
            }
          }
        } else {
          // Single selection mode
          $swatchContainer.find(".pioImageSwatch").removeClass("pio-swatch-selected");
          $swatch.addClass("pio-swatch-selected");
        }
        
        // Get selected values and prices (option-wise for display)
        var selectedSwatches = $swatchContainer.find(".pioImageSwatch.pio-swatch-selected");
        var selectedValues = [];
        var totalPrice = 0;
        var displayParts = [];
        
        selectedSwatches.each(function() {
          var value = $pioobject(this).data("value");
          var price = parseFloat($pioobject(this).data("price")) || 0;
          selectedValues.push(value);
          totalPrice += price;
          var part = value;
          if (price > 0) {
            part += " (+" + pioCurrencyConverter(storeCurrency, price) + ")";
          }
          displayParts.push(part);
        });
        
        // Update selected value display (option-wise price)
        var $selectedDisplay = $field.find(".pio-selected-value");
        if (selectedValues.length > 0) {
          // If div doesn't exist, create it
          if ($selectedDisplay.length === 0) {
            var hiddenInputId = $field.find(".pioImageSwatch__original").attr("id");
            var cartName = hiddenInputId ? hiddenInputId.replace("_original", "") : "";
            $selectedDisplay = $pioobject('<div class="pio-selected-value" id="' + cartName + '_selected"></div>');
            $field.find("label").after($selectedDisplay);
          }
          $selectedDisplay.text(displayParts.join(", "));
        } else {
          // If div exists but no values, remove it
          if ($selectedDisplay.length > 0) {
            $selectedDisplay.remove();
          }
        }
        
        var $hidden = $field.find(".pioImageSwatch__original");
        var selectedValue = selectedValues.join(",");
        
        if (selectedValue != "") {
          $hidden.attr("pio-price", totalPrice > 0 ? totalPrice : "");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            totalPrice
          );
          if (totalPrice > 0) {
            $hidden.val(selectedValue + " |" + priceWithCurrency);
          } else {
            $hidden.val(selectedValue);
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION
        var error = "";
        var isRequired = $swatch.hasClass("required");
        var currentSelection = selectedValues.length;
        
        if (isRequired && currentSelection === 0) {
          error = "This field is required";
        } else if (currentSelection < minSelection) {
          error = "Please select at least " + minSelection + " option(s)";
        } else if (currentSelection > maxSelection) {
          error = "Please select at most " + maxSelection + " option(s)";
        }
        
        pioRenderError($field, error);
      });
  
      //For checkbox field price
      $pioobject(document).on("change", ".pioCheckBox", function () {
        var $checkbox = $pioobject(this);
        var $field = $checkbox.closest(".td-line-item-field");
        
        // PRICE SYNC
        var pioOptPrice = 0;
        var pioSelectedChk = $checkbox
          .parents(".td-content")
          .find(".pioCheckBox:checkbox:checked");
        pioSelectedChk
          .map(function () {
            //return $pioobject(this).attr('pio-price');
            if ($pioobject(this).attr("pio-price") != "") {
              pioOptPrice += Number($pioobject(this).attr("pio-price"));
            }
          })
          .get();
        var pioSelectedCheckbox = pioSelectedChk
          .map(function () {
            return this.value;
          })
          .get();
        var pioSelectedOptions = pioSelectedCheckbox.join(",");
        var $hidden = $checkbox
          .parents(".td-content")
          .find(".pioCheckBox__original");
        if (pioSelectedOptions != "") {
          $hidden.attr("pio-price", pioOptPrice > 0 ? pioOptPrice : "");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            pioOptPrice
          );
          if (
            pioOptPrice != "" &&
            pioOptPrice != null
          ) {
            $hidden.val(pioSelectedOptions + " |" + priceWithCurrency);
          } else {
            $hidden.val(pioSelectedOptions);
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION: field is required = at least one checkbox in group must be selected
        var error = "";
        var checkboxGroupRequired = $field.attr("data-checkbox-group-required") === "1" || $field.hasClass("pio-checkbox-group-required");
        if (checkboxGroupRequired && !pioSelectedCheckbox.length) {
          error = "This field is required";
        }
        pioRenderError($field, error);
      });

      //For color swatch field
      $pioobject(document).on("click", ".pioColorSwatch", function () {
        var $swatch = $pioobject(this);
        var $field = $swatch.closest(".td-line-item-field");
        var $swatchContainer = $swatch.closest(".pio-swatch-container");
        var allowMultiple = $field.data("multiple") == "1";
        var minSelection = parseInt($field.data("min")) || 0;
        var maxSelection = parseInt($field.data("max")) || 999;
        
        // Toggle selection
        if (allowMultiple) {
          // Multiple selection mode
          var selectedCount = $swatchContainer.find(".pioColorSwatch.pio-swatch-selected").length;
          
          if ($swatch.hasClass("pio-swatch-selected")) {
            // Deselect if above minimum
            if (selectedCount > minSelection) {
              $swatch.removeClass("pio-swatch-selected");
            }
          } else {
            // Select if below maximum
            if (selectedCount < maxSelection) {
              $swatch.addClass("pio-swatch-selected");
            }
          }
        } else {
          // Single selection mode
          $swatchContainer.find(".pioColorSwatch").removeClass("pio-swatch-selected");
          $swatch.addClass("pio-swatch-selected");
        }
        
        // Get selected values and prices (option-wise for display)
        var selectedSwatches = $swatchContainer.find(".pioColorSwatch.pio-swatch-selected");
        var selectedValues = [];
        var totalPrice = 0;
        var displayParts = [];
        
        selectedSwatches.each(function() {
          var value = $pioobject(this).data("value");
          var price = parseFloat($pioobject(this).data("price")) || 0;
          selectedValues.push(value);
          totalPrice += price;
          var part = value;
          if (price > 0) {
            part += " (+" + pioCurrencyConverter(storeCurrency, price) + ")";
          }
          displayParts.push(part);
        });
        
        // Update selected value display (option-wise price)
        var $selectedDisplay = $field.find(".pio-selected-value");
        if (selectedValues.length > 0) {
          // If div doesn't exist, create it
          if ($selectedDisplay.length === 0) {
            var hiddenInputId = $field.find(".pioColorSwatch__original").attr("id");
            var cartName = hiddenInputId ? hiddenInputId.replace("_original", "") : "";
            $selectedDisplay = $pioobject('<div class="pio-selected-value" id="' + cartName + '_selected"></div>');
            $field.find("label").after($selectedDisplay);
          }
          $selectedDisplay.text(displayParts.join(", "));
        } else {
          // If div exists but no values, remove it
          if ($selectedDisplay.length > 0) {
            $selectedDisplay.remove();
          }
        }
        
        var $hidden = $field.find(".pioColorSwatch__original");
        var selectedValue = selectedValues.join(",");
        
        if (selectedValue != "") {
          $hidden.attr("pio-price", totalPrice > 0 ? totalPrice : "");
          var priceWithCurrency = pioCurrencyConverter(
            storeCurrency,
            totalPrice
          );
          if (totalPrice > 0) {
            $hidden.val(selectedValue + " |" + priceWithCurrency);
          } else {
            $hidden.val(selectedValue);
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION
        var error = "";
        var isRequired = $swatch.hasClass("required");
        var currentSelection = selectedValues.length;
        
        if (isRequired && currentSelection === 0) {
          error = "This field is required";
        } else if (currentSelection < minSelection) {
          error = "Please select at least " + minSelection + " option(s)";
        } else if (currentSelection > maxSelection) {
          error = "Please select at most " + maxSelection + " option(s)";
        }
        
        pioRenderError($field, error);
      });
  
      //For radio button field price
      $pioobject(document).on("change", ".pioRadioButton", function () {
        var $radio = $pioobject(this);
        var $field = $radio.closest(".td-line-item-field");
        var $hidden = $radio
          .parents(".td-content")
          .find(".pioRadioButton__original");
        
        // PRICE SYNC
        var pioPrice = $radio.attr("pio-price");
        $hidden.attr("pio-price", pioPrice != "" ? pioPrice : "");
        if (pioPrice != "") {
          var priceWithCurrency = pioCurrencyConverter(storeCurrency, pioPrice);
          pioPrice = " |" + priceWithCurrency;
        }
        if ($radio.val() != "") {
          if (pioPrice != "" && pioPrice != null) {
            $hidden.val($radio.val() + pioPrice);
          } else {
            $hidden.val($radio.val());
          }
        } else {
          $hidden.attr("pio-price", "");
          $hidden.val(" ");
        }

        // VALIDATION
        var error = "";
        var isRequired = $radio.attr("required");
        if (isRequired && !$radio.is(":checked")) {
          // Check if any radio in the group is checked
          var anyChecked = $radio
            .closest(".td-content")
            .find(".pioRadioButton:checked").length > 0;
          if (!anyChecked) {
            error = "This field is required";
          }
        }
        pioRenderError($field, error);
        
        if (typeof pioUpdateTotalPriceMessage === "function") pioUpdateTotalPriceMessage();
        return true;
      });

      // Update total price message when any option changes (select, button, swatch, checkbox, radio, text, etc.)
      $pioobject(document).on("change input click", ".pio-multiple-options", function () {
        if (typeof pioUpdateTotalPriceMessage === "function") pioUpdateTotalPriceMessage();
      });

      //For pop-up modal
      $pioobject(document).on("click", ".pio-popup-trigger", function () {
        var modalId = $pioobject(this).data("modal-id");
        var $modal = $pioobject("#" + modalId);
        $modal.addClass("pio-modal-active");
        $pioobject("body").addClass("pio-modal-open");
      });

      $pioobject(document).on("click", ".pio-modal-close, .pio-modal-overlay", function (e) {
        // Close modal when clicking close button or overlay (but not modal content)
        if ($pioobject(e.target).hasClass("pio-modal-overlay") || $pioobject(e.target).hasClass("pio-modal-close")) {
          var $modal = $pioobject(this).closest(".pio-modal-overlay");
          $modal.removeClass("pio-modal-active");
          $pioobject("body").removeClass("pio-modal-open");
        }
      });

      // Close modal on ESC key
      $pioobject(document).on("keydown", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
          $pioobject(".pio-modal-overlay.pio-modal-active").removeClass("pio-modal-active");
          $pioobject("body").removeClass("pio-modal-open");
        }
      });
  
      //Checkout
      var pioElimentcheck =
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]';
      $pioobject("body").on("click", pioElimentcheck, function (e) {
        if ((isOldUserFlag && planTierValue == 3) || (!isOldUserFlag && planTierValue != 1)) {
          e.preventDefault();
          pioDraftCreate();
        }
      });
  
      //Convert the price with symbol
      pioCurrencyConverter = function (format, amountData) {
        var pioShopCurrency = format
          .replace("{{amount}}", amountData)
          .replace("{{ amount }}", amountData)
          .replace("{{amount_with_comma_separator}}", amountData)
          .replace("{{ amount_with_comma_separator }}", amountData)
          .replace("{{amount_no_decimals}}", amountData)
          .replace("{{ amount_no_decimals }}", amountData)
          .replace("{{amount_with_apostrophe_separator}}", amountData)
          .replace("{{ amount_with_apostrophe_separator }}", amountData)
          .replace("{{amount_no_decimals_with_comma_separator}}", amountData)
          .replace("{{ amount_no_decimals_with_comma_separator }}", amountData)
          .replace(".00", "");
        return pioShopCurrency;
      };

      // Update total options price message (sum of all selected/entered field prices)
      pioUpdateTotalPriceMessage = function () {
        var $container = $pioobject(".pio-multiple-options");
        if (!$container.length) return;
        var total = 0;
        $container.find(".td-line-item-field").each(function () {
          var $field = $pioobject(this);
          $field.find(".pioSelect option:selected").each(function () {
            total += parseFloat($pioobject(this).data("price")) || 0;
          });
          $field.find(".pioButton.pio-button-selected").each(function () {
            total += parseFloat($pioobject(this).data("price")) || 0;
          });
          $field.find(".pioCheckBox:checked").each(function () {
            total += parseFloat($pioobject(this).attr("pio-price")) || 0;
          });
          $field.find(".pioRadioButton:checked").each(function () {
            total += parseFloat($pioobject(this).attr("pio-price")) || 0;
          });
          $field.find(".pioImageSwatch.pio-swatch-selected").each(function () {
            total += parseFloat($pioobject(this).data("price")) || 0;
          });
          $field.find(".pioColorSwatch.pio-swatch-selected").each(function () {
            total += parseFloat($pioobject(this).data("price")) || 0;
          });
          $field.find("input[class*='__original'][pio-price], textarea[class*='__original'][pio-price]").not(".pioSelect__original, .pioButton__original, .pioImageSwatch__original, .pioCheckBox__original, .pioColorSwatch__original, .pioRadioButton__original").each(function () {
            var v = $pioobject(this).val();
            if (v && $pioobject.trim(v) !== "" && v !== " ") {
              total += parseFloat($pioobject(this).attr("pio-price")) || 0;
            }
          });
        });
        var totalText = (typeof storeCurrency !== "undefined" && storeCurrency && typeof pioCurrencyConverter === "function")
          ? pioCurrencyConverter(storeCurrency, total) : String(total);
        var $wrapper = $container.find(".pio-options-total-price-wrapper");
        $container.find(".pio-options-total-price-amount").text(totalText);
        if (total > 0) {
          $wrapper.addClass("pio-options-total-price--visible").show();
        } else {
          $wrapper.removeClass("pio-options-total-price--visible").hide();
        }
      };

      // Polaris-style error renderer
      function pioRenderError($field, message) {
        $field.removeClass("pio-has-error");
        $field.find(".pio-error-text").remove();

        if (!message) return;

        $field.addClass("pio-has-error");
        $field.find(".td-content").append(
          '<div class="pio-error-text">' + message + "</div>"
        );
      }

      // Text validation logic
      function pioValidateTextField($input) {
        var value = $input.val().trim();
        var min = $input.attr("minlength");
        var max = $input.attr("maxlength");
        var required = $input.attr("required");

        if (required && !value) {
          return "This field is required";
        }
        if (min && value.length < parseInt(min)) {
          return "Minimum " + min + " characters required";
        }
        return "";
      }

      function pioNormalizePropertiesInputs($form) {
        $form
          .find('.pio-multiple-options [name^="properties["], .pio-multiple-options [data-pio-name]')
          .each(function () {
            var $input = $pioobject(this);
            var currentName = $input.attr("name");
            var originalName = $input.attr("data-pio-name") || currentName;

            if (originalName) {
              $input.attr("data-pio-name", originalName);
            }

            // Keep file input names intact so uploaded files remain in the request.
            if (
              this &&
              this.tagName &&
              this.tagName.toLowerCase() === "input" &&
              this.type === "file"
            ) {
              if (originalName) {
                $input.attr("name", originalName);
              }
              return;
            }

            var val = ($input.val() || "").toString().trim().toLowerCase();
            if (val == "null" || val == "" || val == "undefined") {
              $input.removeAttr("name");
            } else if (originalName) {
              $input.attr("name", originalName);
            }
          });
      }

      function pioBuildCleanFormData(formEl) {
        var rawFormData = new FormData(formEl);
        var cleanFormData = new FormData();
        var propertyValues = {};
        var propertyOrder = [];

        rawFormData.forEach(function (value, key) {
          var isPropertyKey = key && key.indexOf("properties[") === 0;

          if (!isPropertyKey) {
            cleanFormData.append(key, value);
            return;
          }

          var isStringValue = typeof value === "string";
          var normalizedValue = isStringValue
            ? value.toString().trim().toLowerCase()
            : value;

          if (
            isStringValue &&
            (normalizedValue == "" || normalizedValue == "null" || normalizedValue == "undefined")
          ) {
            return;
          }

          if (!(key in propertyValues)) {
            propertyOrder.push(key);
          }

          // Duplicate properties can appear in repeated blocks; keep the latest non-empty value.
          propertyValues[key] = value;
        });

        for (var i = 0; i < propertyOrder.length; i++) {
          var propertyKey = propertyOrder[i];
          cleanFormData.append(propertyKey, propertyValues[propertyKey]);
        }

        return cleanFormData;
      }

      // Before submitting the product form, strip empty option properties
      $pioobject(document).on("submit", 'form[action*="/cart/add"]', function () {
        var $form = $pioobject(this).closest('form');
        pioNormalizePropertiesInputs($form);
      });
  
      //Draft order create
      pioDraftCreate = function () {
        if (pioJson != "") {
          var pioSettings = pioJson.setting;
          if (pioSettings.app_status == 1) {  
            $pioobject
              .getJSON("/cart.js", function () {})
              .then(function (response) {
                var draftData = 0;
                //Ajax For Creating Draft order
                const draftURL = $pioobject.ajax({
                  type: "POST",
                  async: false,
                  cache: false,
                  url: pioBasePath + "api/checkout-draft",
                  dataType: "json",
                  data: {
                    shop: pioShop,
                    pioCart: response,
                    shopCurrency: storeCurrency,
                  },
                  success: function (draftdata) {
                    const drafURL = draftdata;
                    // return drafURL;
  
                    if(draftdata != 0){
                      return drafURL;
                    }else{
                      return '/checkout';
                    }
                  },
                  error: function (error) {
                    console.log(error);
                    return 0;
                  }
                });
                // Redirect based on the Draft order response
                if (draftURL.responseText != 0) {
                  setTimeout(function() {
                    window.location.href = draftURL.responseText;
                  }, 500)
                } else {
                  window.location.href = "/checkout";
                }
              });
          }else{
            window.location.href = "/checkout";
          }
        }else{
          window.location.href = "/checkout";
        }
      };
      $pioobject("body").on("click", "#pioWrapper", function (e) {

        e.preventDefault();
        e.stopPropagation();
  
        //Check validation
        var pioValidFlag = pioFieldValidations();
        
        //Stop process validation fails 
        if (pioValidFlag == false) {
          return false;
        }else{
          //Carry on the further validation pass
          var pioBuyItNowButtonContainer = document.querySelector(
            '[class*="shopify-payment-button"]'
          );
          
          // send to draft order/normal order according to the plan
          if ((isOldUserFlag && planTierValue != 3) || (!isOldUserFlag && planTierValue == 1)) {
            if (pioBuyItNowButtonContainer != null) {
              pioDisableBuyItNowButtonWrapper();
            }
          } else {
            var tdProductForm = $(this).closest("form");
            pioNormalizePropertiesInputs(tdProductForm);
            var tdFormData = pioBuildCleanFormData(tdProductForm[0]);
            $.ajax({
              url: "/cart/add.js",
              dataType: "json",
              type: "post",
              cache: false,
              contentType: false,
              processData: false,
              data: tdFormData,
              success: function (response) {
                pioDraftCreate();
              },
            });
          }
        }
      });
  
      // Call function
      $pioobject("div").pioLoad();
    })(window.jQuery, window, document);
      });
  }
  
